import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { scrollToTop } from '../../utils/scrollUtils';
import {
  Container,
  Box,
  Button,
  Typography,
  Paper,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
  Grid,
  Card,
  CardContent,
  CardMedia,
  Chip,
  IconButton,
  // Stepper,
  // Step,
  // StepLabel,
  // StepContent,
  RadioGroup,
  Icon,
  Radio,
  FormControlLabel,
  Stepper,
  Step,
  StepLabel,
  StepContent,
  Alert
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
// import HealthAndSafetyIcon from '@mui/icons-material/HealthAndSafety';
import { 
  CheckCircle, 
  RadioButtonUnchecked, 
  CheckCircleOutline, 
  ErrorOutline,
  Lightbulb as LightbulbIcon,
  Info as InfoIcon,
  Security as SecurityIcon,
  // AccessibilityNew as AccessibilityNewIcon,
  // FiberManualRecord as FiberManualRecordIcon
} from '@mui/icons-material';
import QuizIcon from '@mui/icons-material/Quiz';
import ArrowRight from '@mui/icons-material/ArrowRight';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import AccessibilityIcon from '@mui/icons-material/Accessibility';
import HeadsetMicIcon from '@mui/icons-material/HeadsetMic';
import PanToolIcon from '@mui/icons-material/PanTool';
import FaceIcon from '@mui/icons-material/Face';
// import AirIcon from '@mui/icons-material/Air';
import LoopIcon from '@mui/icons-material/Loop';
import RepeatIcon from '@mui/icons-material/Repeat';
// import StarIcon from '@mui/icons-material/Star';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import TimerIcon from '@mui/icons-material/Timer';
import VideoFileIcon from '@mui/icons-material/VideoFile';
import SummarizeIcon from '@mui/icons-material/Summarize';
import VisibilityIcon from '@mui/icons-material/Visibility';
import MonitorHeartIcon from '@mui/icons-material/MonitorHeart';
import TrackChangesIcon from '@mui/icons-material/TrackChanges';
import AssessmentIcon from '@mui/icons-material/Assessment';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import WarningIcon from '@mui/icons-material/Warning';
import PersonIcon from '@mui/icons-material/Person';
import PhoneIcon from '@mui/icons-material/Phone';
import CallIcon from '@mui/icons-material/Call';
import AirIcon from '@mui/icons-material/Air';
import ColorizeIcon from '@mui/icons-material/Colorize';
import AccessibilityNewIcon from '@mui/icons-material/AccessibilityNew';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
// import InfoIcon from '@mui/icons-material/Info';
// import LightbulbIcon from '@mui/icons-material/Lightbulb';
import RefreshIcon from '@mui/icons-material/Refresh';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import PublicIcon from '@mui/icons-material/Public';
import PowerIcon from '@mui/icons-material/Power';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import TouchAppIcon from '@mui/icons-material/TouchApp';
// import PanToolIcon from '@mui/icons-material/PanTool';
import WaterDropIcon from '@mui/icons-material/WaterDrop';
import ContentCutIcon from '@mui/icons-material/ContentCut';
import WatchIcon from '@mui/icons-material/Watch';
import ChildCareIcon from '@mui/icons-material/ChildCare';
import PregnantWomanIcon from '@mui/icons-material/PregnantWoman';
import DeviceHubIcon from '@mui/icons-material/DeviceHub';
import ElectricBoltIcon from '@mui/icons-material/ElectricBolt';
import BatteryChargingFullIcon from '@mui/icons-material/BatteryChargingFull';
import AssignmentIcon from '@mui/icons-material/Assignment';
import BuildCircleIcon from '@mui/icons-material/BuildCircle';
import RoomIcon from '@mui/icons-material/Room';
import MemoryIcon from '@mui/icons-material/Memory';
import DashboardIcon from '@mui/icons-material/Dashboard';
import WorkIcon from '@mui/icons-material/Work';
import MedicalServicesIcon from '@mui/icons-material/MedicalServices';
import DescriptionIcon from '@mui/icons-material/Description';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import TransformIcon from '@mui/icons-material/Transform';
import GroupIcon from '@mui/icons-material/Group';
import PsychologyIcon from '@mui/icons-material/Psychology';
// import CheckCircleOutline from '@mui/icons-material/CheckCircleOutline';
import WarningAmber from '@mui/icons-material/WarningAmber';
// import LightbulbIcon from '@mui/icons-material/Lightbulb';
import StarIcon from '@mui/icons-material/Star';
// import PanToolIcon from '@mui/icons-material/PanTool';
import FitnessCenterIcon from '@mui/icons-material/FitnessCenter';
import CircleIcon from '@mui/icons-material/Circle';
import RestaurantIcon from '@mui/icons-material/Restaurant';
import MedicationIcon from '@mui/icons-material/Medication';
import PestControlIcon from '@mui/icons-material/PestControl';
import HealthAndSafetyIcon from '@mui/icons-material/HealthAndSafety';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import BoltIcon from '@mui/icons-material/Bolt';
import EmergencyIcon from '@mui/icons-material/Emergency';
import CardMembershipIcon from '@mui/icons-material/CardMembership';
import UpdateIcon from '@mui/icons-material/Update';
import NewReleasesIcon from '@mui/icons-material/NewReleases';
import MedicalInformationIcon from '@mui/icons-material/MedicalInformation';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import { Timeline, TimelineItem, TimelineSeparator, TimelineConnector, TimelineDot, TimelineContent } from '@mui/lab';
// import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import { useModuleProgress } from '../../context/ModuleProgressContext';
import { module1_lessons, module2_lessons, module3_lessons, module4_lessons, module5_lessons, module6_lessons, module7_lessons, module8_lessons } from '../BLSCPRCourse';
import ModuleSidebar from '../../components/navigation/ModuleSidebar';

const LessonSidebar = ({ moduleTitle, lessons, currentLessonId }) => {
  const navigate = useNavigate();
  const { moduleId } = useParams();

  const handleLessonClick = (lessonId) => {
    navigate(`/bls-cpr/${moduleId}/${lessonId}`);
    scrollToTop();
  };
  return (
    <Box sx={{ width: '100%' }}>
      <Typography 
        variant="subtitle1" 
        sx={{ 
          mb: 2, 
          fontWeight: 600,
          color: 'text.primary'
        }}
      >
        {moduleTitle}
      </Typography>
      <List sx={{ pt: 0 }}>
        {lessons.map((lesson, index) => (
          <ListItem
            key={lesson.id}
            onClick={() => handleLessonClick(lesson.id)}
            sx={{
              px: 0,
              py: 0.5,
              cursor: 'pointer',
              '&:hover': {
                bgcolor: 'rgba(25, 118, 210, 0.04)'
              },
              transition: 'background-color 0.2s'
            }}
          >
            <ListItemIcon sx={{ minWidth: 32 }}>
              {lesson.completed ? (
                <CheckCircle sx={{ color: '#4CAF50' }} />
              ) : (
                <RadioButtonUnchecked sx={{ color: 'text.secondary' }} />
              )}
            </ListItemIcon>
            <ListItemText
              primary={`${index + 1}. ${lesson.title}`}
              primaryTypographyProps={{
                sx: {
                  fontSize: '0.9rem',
                  fontWeight: lesson.id === currentLessonId ? 500 : 400,
                  color: lesson.id === currentLessonId ? 'text.primary' : 'text.secondary',
                  lineHeight: 1.4
                }
              }}
            />
          </ListItem>
        ))}
      </List>
    </Box>
  );
};

const getIcon = (iconName, props = {}) => {
  const iconMap = {
    WaterDrop: WaterDropIcon,
    HealthAndSafety: HealthAndSafetyIcon,
    ContentCut: ContentCutIcon,
    Watch: WatchIcon,
    ChildCare: ChildCareIcon,
    PregnantWoman: PregnantWomanIcon,
    DeviceHub: DeviceHubIcon,
    Battery: BatteryChargingFullIcon,
    Assignment: AssignmentIcon,
    BuildCircle: BuildCircleIcon,
    Room: RoomIcon,
    Power: PowerIcon,
    VolumeUp: VolumeUpIcon,
    TouchApp: TouchAppIcon,
    PanTool: PanToolIcon,
    TrendingUp: TrendingUpIcon,
    Timer: TimerIcon,
    Public: PublicIcon,
    MonitorHeart: MonitorHeartIcon,
    Air: AirIcon,
    Warning: WarningIcon,
    SupportAgent: SupportAgentIcon,
    Transform: TransformIcon,
    Description: DescriptionIcon,
    Group: GroupIcon,
    Psychology: PsychologyIcon,
    Assessment: AssessmentIcon,
    AccessibilityNew: AccessibilityNewIcon
  };

  const IconComponent = iconMap[iconName];
  return IconComponent ? <IconComponent {...props} /> : null;
};

const getLessonIcon = (type) => {
  switch (type) {
    case 'Interactive Lesson':
      return <LocalHospitalIcon />;
    case 'Quiz':
      return <QuizIcon />;
    case 'Video':
      return <VideoFileIcon />;
    case 'Summary':
      return <SummarizeIcon />;
    default:
      return <MenuBookIcon />;
  }
};

const BLSCPRModule = () => {
  // Extract URL parameters
  const params = useParams();
  // Handle both URL formats: /bls-cpr/:moduleId/:lessonId and /bls-cpr/module/:moduleId/lesson/:lessonId
  const moduleId = params.moduleId;
  // If we're using the /module/:moduleId/lesson/:lessonId format
  const lessonId = params.lessonId;
  const navigate = useNavigate();
  const [currentModule, setCurrentModule] = useState(null);
  const [currentLessonId, setCurrentLessonId] = useState(lessonId || '1.1');
  const [activeLesson, setActiveLesson] = useState(null);
  const [quizAnswers, setQuizAnswers] = useState({});
  const [quizFeedback, setQuizFeedback] = useState({});
  const [showAllAnswers, setShowAllAnswers] = useState(false);
  const [showAnswers, setShowAnswers] = useState(false);

  const handleAnswerSelect = (questionId, selectedAnswer) => {
    // Ensure the answer is stored as a string for consistent comparison
    setQuizAnswers(prev => ({
      ...prev,
      [questionId]: String(selectedAnswer)
    }));
    // Clear feedback when a new answer is selected
    setQuizFeedback(prev => ({
      ...prev,
      [questionId]: null
    }));
  };

  const handleCheckAnswer = (questionId) => {
    if (!activeLesson?.content?.quiz?.questions) return;
    
    const question = activeLesson.content.quiz.questions.find(q => q.id === questionId);
    if (!question) return;
    
    const userAnswer = quizAnswers[questionId];
    if (userAnswer === undefined || userAnswer === null) return;
    
    // Convert both values to strings and trim any whitespace for comparison
    const userAnswerStr = String(userAnswer).trim();
    const correctAnswerStr = String(question.correctAnswer).trim();
    const isCorrect = userAnswerStr === correctAnswerStr;
    
    setQuizFeedback(prev => ({
      ...prev,
      [questionId]: {
        isCorrect,
        explanation: question.explanation || (isCorrect ? 'Correct answer!' : `Incorrect. The correct answer is: ${question.options[Number(correctAnswerStr)]}`)
      }
    }));
  };
  
  const handleSubmitAllAnswers = () => {
    if (!activeLesson?.content?.quiz?.questions) return;
    
    const feedback = {};
    activeLesson.content.quiz.questions.forEach(question => {
      // Convert both values to strings for comparison
      const userAnswer = String(quizAnswers[question.id]);
      const correctAnswer = String(question.correctAnswer);
      const isCorrect = userAnswer === correctAnswer;
      
      feedback[question.id] = {
        isCorrect,
        explanation: question.explanation || (isCorrect ? 'Correct!' : 'Incorrect answer.')
      };
    });
    
    setQuizFeedback(feedback);
    setShowAllAnswers(true);
    setShowAnswers(true);
  };
  
  const handleRetryQuiz = () => {
    setQuizAnswers({});
    setQuizFeedback({});
    setShowAllAnswers(false);
    setShowAnswers(false);
  };
  const [isLoading, setIsLoading] = useState(true);
  const { moduleProgress, setModuleProgress } = useModuleProgress();

  // Get module data based on moduleId
  useEffect(() => {
    setIsLoading(true);
    let moduleData;
    switch (moduleId) {
      case 'intro':
      case 'introduction':
        moduleData = {
          id: 'intro',
          title: 'Introduction to BLS and CPR',
          description: 'Overview of Basic Life Support and CPR fundamentals',
          lessons: module1_lessons,
          icon: 'School'
        };
        break;
      case 'assessment':
        moduleData = {
          id: 'assessment',
          title: 'Patient Assessment and Scene Safety',
          lessons: module2_lessons
        };
        break;
      case 'adult-bls':
        moduleData = {
          id: 'adult-bls',
          title: 'Recognizing an Acutely Unwell Patient',
          lessons: module3_lessons
        };
        break;
      case 'cpr-techniques':
        moduleData = {
          id: 'cpr-techniques',
          title: 'Adult Basic Life Support',
          lessons: module4_lessons
        };
        break;
      case 'aed':
        moduleData = {
          id: 'aed',
          title: 'Automated External Defibrillators (AEDs)',
          lessons: module5_lessons
        };
        break;
      case 'emergency-response':
        moduleData = {
          id: 'emergency-response',
          title: 'Responding to Emergency Situations',
          lessons: module7_lessons
        };
        break;
      case 'post-resuscitation':
        moduleData = {
          id: 'post-resuscitation',
          title: 'Post-Resuscitation Care and Documentation',
          lessons: module6_lessons
        };
        break;
      case 'conclusion':
        moduleData = {
          id: 'conclusion',
          title: 'Course Conclusion',
          lessons: module8_lessons
        };
        break;
      default:
        console.error('Unknown module:', moduleId);
        navigate('/bls-cpr');
        return;
    }

    setCurrentModule(moduleData);
    if (moduleData) {
      if (lessonId) {
        const lesson = moduleData.lessons.find(l => l.id === lessonId);
        if (lesson) {
          setActiveLesson(lesson);
          setCurrentLessonId(lesson.id);
        } else {
          setActiveLesson(moduleData.lessons[0]);
        }
      } else {
        setActiveLesson(moduleData.lessons[0]);
      }
    }
    setIsLoading(false);
  }, [moduleId, lessonId]);

  const handleNextLesson = () => {
    if (!currentModule || !activeLesson) return;
    
    const currentIndex = currentModule.lessons.findIndex(lesson => lesson.id === activeLesson.id);
    if (currentIndex < currentModule.lessons.length - 1) {
      const nextLesson = currentModule.lessons[currentIndex + 1];
      setActiveLesson(nextLesson);
      setCurrentLessonId(nextLesson.id);
      navigate(`/bls-cpr/${currentModule.id}/${nextLesson.id}`);
      scrollToTop();
    }
  };

  const handlePreviousLesson = () => {
    if (!currentModule || !activeLesson) return;
    
    const currentIndex = currentModule.lessons.findIndex(lesson => lesson.id === activeLesson.id);
    if (currentIndex > 0) {
      const previousLesson = currentModule.lessons[currentIndex - 1];
      setActiveLesson(previousLesson);
      setCurrentLessonId(previousLesson.id);
      navigate(`/bls-cpr/${currentModule.id}/${previousLesson.id}`);
      scrollToTop();
    }
  };

  const hasNextLesson = currentModule && activeLesson && 
    currentModule.lessons.findIndex(lesson => lesson.id === activeLesson.id) < currentModule.lessons.length - 1;

  const hasPreviousLesson = currentModule && activeLesson && 
    currentModule.lessons.findIndex(lesson => lesson.id === activeLesson.id) > 0;

  const handleBack = () => {
    navigate('/courses/bls-cpr');
    scrollToTop();
  };

  if (!currentModule || isLoading) {
    return (
      <Container maxWidth="lg" sx={{ py: 4 }}>
        <Paper sx={{ p: 4 }}>
          <Typography>Loading module content...</Typography>
        </Paper>
      </Container>
    );
  }

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Box sx={{ mb: 4 }}>
        <Button
          startIcon={<ArrowBackIcon />}
          onClick={() => navigate('/bls-cpr')}
          sx={{
            color: 'text.secondary',
            '&:hover': {
              bgcolor: 'transparent',
              color: 'primary.main'
            }
          }}
        >
          Back to Learning Modules
        </Button>
      </Box>

      <Grid container spacing={4}>
        {/* Sidebar */}
        <Grid item xs={12} md={3}>
          <Paper elevation={2} sx={{ p: 3, borderRadius: 2 }}>
            {currentModule && (
              <LessonSidebar
                moduleTitle={currentModule.title}
                lessons={currentModule.lessons}
                currentLessonId={activeLesson?.id}
              />
            )}
          </Paper>
        </Grid>

        {/* Main Content */}
        <Grid item xs={12} md={9}>
          {isLoading ? (
            <Paper sx={{ p: 4, textAlign: 'center' }}>
              <Typography>Loading...</Typography>
            </Paper>
          ) : currentModule && activeLesson ? (
            <Box>
              {/* Header Card */}
              <Paper 
                elevation={2} 
                sx={{ 
                  p: 4, 
                  mb: 4, 
                  borderRadius: 2,
                  background: 'linear-gradient(45deg, #1976d2 30%, #2196f3 90%)',
                  color: 'white'
                }}
              >
                <Typography variant="h4" sx={{ mb: 2, fontWeight: 600 }}>
                  {activeLesson.title}
                </Typography>
                <Typography variant="subtitle1" sx={{ opacity: 0.9 }}>
                  {activeLesson.description}
                </Typography>
              </Paper>

              {/* Introduction */}
              {activeLesson.content.introduction && (
                <Paper elevation={1} sx={{ p: 4, mb: 4, borderRadius: 2 }}>
                  <Typography variant="body1" sx={{ lineHeight: 1.7 }}>
                    {activeLesson.content.introduction}
                  </Typography>
                </Paper>
              )}

              {/* Learning Objectives */}
              {activeLesson.content.objectives && (
                <Paper 
                  elevation={1} 
                  sx={{ 
                    p: 4, 
                    mb: 4, 
                    borderRadius: 2,
                    borderLeft: '4px solid #4caf50'
                  }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                    <MenuBookIcon sx={{ mr: 1, color: '#4caf50' }} />
                    <Typography variant="h6" sx={{ fontWeight: 600 }}>
                      Learning Objectives
                    </Typography>
                  </Box>
                  <List>
                    {activeLesson.content.objectives.map((objective, index) => (
                      <ListItem key={index} sx={{ py: 1 }}>
                        <ListItemIcon>
                          <ArrowRight sx={{ color: '#4caf50' }} />
                        </ListItemIcon>
                        <ListItemText 
                          primary={objective}
                          primaryTypographyProps={{
                            sx: { fontWeight: 500 }
                          }}
                        />
                      </ListItem>
                    ))}
                  </List>
                </Paper>
              )}

              {/* Main Content */}
              {activeLesson.content.mainContent && (
                <Box sx={{ mb: 4 }}>
                  {activeLesson.content.id!='4.7'&&activeLesson.content.mainContent && Object.entries(activeLesson.content.mainContent).map(([key, section], index) => {
                    // Handle the keyIndicators section
                    const sectionToRender = key === 'keyIndicators' ? { ...section } : section;
                    return (
                    <Paper 
                      key={key} 
                      elevation={1} 
                      sx={{ 
                        p: 4, 
                        mb: 3, 
                        borderRadius: 2,
                        borderLeft: '4px solid #1976d2'
                      }}
                    >
                      <Typography 
                        variant="h6" 
                        sx={{ 
                          mb: 3,
                          fontWeight: 600,
                          color: '#1976d2',
                          display: 'flex',
                          alignItems: 'center'
                        }}
                      >
                        <HealthAndSafetyIcon sx={{ mr: 1 }} />
                        {sectionToRender.title}
                      </Typography>

                      {sectionToRender.content && (
                        <Typography   
                          variant="body1" 
                          sx={{ 
                            mb: 3,
                            lineHeight: 1.7
                          }}
                        >
                          {sectionToRender.content}
                        </Typography>
                      )}
                      
                      {/* Images for Cardiac and Non-Cardiac Causes */}
                      {sectionToRender.image && (
                        <Box sx={{ my: 3, textAlign: 'center' }}>
                          <img 
                            src={sectionToRender.image} 
                            alt={sectionToRender.imageAlt || 'Lesson image'} 
                            style={{ 
                              maxWidth: '100%', 
                              height: 'auto', 
                              // borderRadius: '8px',
                              // boxShadow: '0 4px 8px rgba(0,0,0,0.1)'
                            }} 
                          />
                          {sectionToRender.imageCaption && (
                            <Typography variant="caption" sx={{ display: 'block', mt: 1, color: 'text.secondary' }}>
                              {sectionToRender.imageCaption}
                            </Typography>
                          )}
                        </Box>
                      )}
                      
                      {/* Special Image Gallery for Steps to Perform the Primary Survey */}
                      {key === 'drsabcdApproach' && sectionToRender.lessonImages && (
                        <Box 
                          sx={{ 
                            mt: 4, 
                            mb: 4
                          }}
                        >
                          <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                            <MenuBookIcon sx={{ mr: 1, color: '#1976d2' }} />
                            <Typography variant="h6" sx={{ fontWeight: 600 }}>
                              Primary Survey Step-by-Step Visual Guide
                            </Typography>
                          </Box>
                          
                          {sectionToRender.lessonImages.map((image, index) => (
                            <Box 
                              key={index}
                              sx={{ 
                                mb: 4,
                                display: 'flex',
                                flexDirection: 'column',
                                width: '100%'
                              }}
                            >
                              <Box 
                                sx={{ 
                                  mb: 2,
                                  // boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
                                  transition: 'transform 0.3s ease',
                                  '&:hover': {
                                    transform: 'translateY(-5px)'
                                  }
                                }}
                              >
                                <img 
                                  src={image.src} 
                                  alt={image.alt} 
                                  style={{ 
                                    width: '100%',
                                    height: 'auto',
                                    display: 'block'
                                  }} 
                                />
                              </Box>
                              <Typography 
                                variant="subtitle1" 
                                sx={{ 
                                  textAlign: 'center',
                                  fontWeight: 600,
                                  color: '#1976d2',
                                  mb: 1
                                }}
                              >
                                {image.caption}
                              </Typography>
                            </Box>
                          ))}
                        </Box>
                      )}

                      {/* Images for Rescue Breaths Lesson */}
                      {key === 'breathDelivery' && sectionToRender.lessonImages && (
                        <Box 
                          sx={{ 
                            mt: 4, 
                            mb: 4
                          }}
                        >
                          <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                            <MenuBookIcon sx={{ mr: 1, color: '#1976d2' }} />
                            <Typography variant="h6" sx={{ fontWeight: 600 }}>
                              Rescue Breath Technique Visual Guide
                            </Typography>
                          </Box>
                          
                          {sectionToRender.lessonImages.map((image, index) => (
                            <Box 
                              key={index}
                              sx={{ 
                                mb: 4,
                                display: 'flex',
                                flexDirection: 'column',
                                width: '100%'
                              }}
                            >
                              <Box 
                                sx={{ 
                                  mb: 2,
                                  boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
                                  // transition: 'transform 0.3s ease',
                                  '&:hover': {
                                    transform: 'translateY(-5px)'
                                  }
                                }}
                              >
                                <img 
                                  src={image.src} 
                                  alt={image.alt} 
                                  style={{ 
                                    width: '100%',
                                    height: 'auto',
                                    display: 'block'
                                  }} 
                                />
                              </Box>
                              <Typography 
                                variant="subtitle1" 
                                sx={{ 
                                  textAlign: 'center',
                                  fontWeight: 600,
                                  color: '#1976d2',
                                  mb: 1
                                }}
                              >
                                {image.caption}
                              </Typography>
                            </Box>
                          ))}
                        </Box>
                      )}

                      {/* Images for AED Introduction Lesson */}
                      {key === 'whatIsAED' && sectionToRender.lessonImages && (
                        <Box 
                          sx={{ 
                            mt: 4, 
                            mb: 4
                          }}
                        >
                          <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                            <MenuBookIcon sx={{ mr: 1, color: '#1976d2' }} />
                            <Typography variant="h6" sx={{ fontWeight: 600 }}>
                              AED Visual Guide
                            </Typography>
                          </Box>
                          
                          {sectionToRender.lessonImages.map((image, index) => (
                            <Box 
                              key={index}
                              sx={{ 
                                mb: 4,
                                display: 'flex',
                                flexDirection: 'column',
                                width: '100%'
                              }}
                            >
                              <Box 
                                sx={{ 
                                  mb: 2,
                                  // boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
                                  transition: 'transform 0.3s ease',
                                  '&:hover': {
                                    transform: 'translateY(-5px)'
                                  }
                                }}
                              >
                                <img 
                                  src={image.src} 
                                  alt={image.alt} 
                                  style={{ 
                                    width: '100%',
                                    height: 'auto',
                                    display: 'block'
                                  }} 
                                />
                              </Box>
                              <Typography 
                                variant="subtitle1" 
                                sx={{ 
                                  textAlign: 'center',
                                  fontWeight: 600,
                                  color: '#1976d2',
                                  mb: 1
                                }}
                              >
                                {image.caption}
                              </Typography>
                            </Box>
                          ))}
                        </Box>
                      )}

                      {/* Images for Choking Algorithm Lesson */}
                      {key === 'algorithm' && sectionToRender.lessonImages && (
                        <Box 
                          sx={{ 
                            mt: 4, 
                            mb: 4
                          }}
                        >
                          <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                            <MenuBookIcon sx={{ mr: 1, color: '#1976d2' }} />
                            <Typography variant="h6" sx={{ fontWeight: 600 }}>
                              Choking Management Visual Guide
                            </Typography>
                          </Box>
                          
                          {sectionToRender.lessonImages.map((image, index) => (
                            <Box 
                              key={index}
                              sx={{ 
                                mb: 4,
                                display: 'flex',
                                flexDirection: 'column',
                                width: '100%'
                              }}
                            >
                              <Box 
                                sx={{ 
                                  mb: 2,
                                  // boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
                                  transition: 'transform 0.3s ease',
                                  '&:hover': {
                                    transform: 'translateY(-5px)'
                                  }
                                }}
                              >
                                <img 
                                  src={image.src} 
                                  alt={image.alt} 
                                  style={{ 
                                    width: '100%',
                                    height: 'auto',
                                    display: 'block'
                                  }} 
                                />
                              </Box>
                              <Typography 
                                variant="subtitle1" 
                                sx={{ 
                                  textAlign: 'center',
                                  fontWeight: 600,
                                  color: '#1976d2',
                                  mb: 1
                                }}
                              >
                                {image.caption}
                              </Typography>
                            </Box>
                          ))}
                        </Box>
                      )}

                      {/* Safety Concerns Section */}
                      {key === 'safetyConcerns' && sectionToRender.concerns && (
                        <Grid container spacing={3}>
                          {sectionToRender.concerns.map((concern, idx) => (
                            <Grid item xs={12} sm={6} key={idx}>
                              <Paper
                                elevation={2}
                                sx={{
                                  p: 2,
                                  height: '100%',
                                  borderLeft: `4px solid ${concern.color}`,
                                  display: 'flex',
                                  flexDirection: 'column'
                                }}
                              >
                                <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                  {getIcon(concern.icon, { color: concern.color })}
                                  <Typography variant="subtitle1" sx={{ ml: 1, fontWeight: 600 }}>
                                    {concern.title}
                                  </Typography>
                                </Box>
                                <Typography variant="body2">{concern.description}</Typography>
                              </Paper>
                            </Grid>
                          ))}
                        </Grid>
                      )}

                      {/* Chain Links Section - Removed duplicate rendering */}
                      {/* {key === 'chainLinks' && (
                        <Box sx={{ mb: 4 }}>
                          <Typography variant="h6" sx={{ mb: 3, color: '#1976d2' }}>
                            {sectionToRender.title}
                          </Typography>
                          <Typography variant="body1" sx={{ mb: 3 }}>
                            {sectionToRender.content}
                          </Typography>
                          <Grid container spacing={3}>
                            {sectionToRender.steps.map((step, idx) => (
                              <Grid item xs={12} md={6} key={idx}>
                                <Paper
                                  elevation={2}
                                  sx={{
                                    p: 3,
                                    height: '100%',
                                    borderLeft: `4px solid ${step.color}`
                                  }}
                                >
                                  <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 600 }}>
                                    {step.name}
                                  </Typography>
                                  <Typography variant="body2" sx={{ mb: step.details ? 2 : 0 }}>
                                    {step.description}
                                  </Typography>
                                  {step.details && (
                                    <Typography variant="body2" color="text.secondary">
                                      {step.details}
                                    </Typography>
                                  )}
                                </Paper>
                              </Grid>
                            ))}
                          </Grid>
                        </Box>
                      )} */}

                      {/* Chain Importance Section */}
                      {key === 'importance' && (
                        <Box sx={{ mb: 4 }}>
                          <Paper
                            elevation={2}
                            sx={{
                              p: 3,
                              borderLeft: '4px solid #ffa726',
                              backgroundColor: '#fff3e0'
                            }}
                          >
                            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                              <LightbulbIcon sx={{ color: '#ffa726', mr: 1 }} />
                              <Typography variant="h6" sx={{ color: '#f57c00' }}>
                                {sectionToRender.title}
                              </Typography>
                            </Box>
                            <Typography variant="body1">
                              {sectionToRender.content}
                            </Typography>
                          </Paper>
                        </Box>
                      )}

                      {/* Special Circumstances Section */}
                      {key === 'specialCircumstances' && sectionToRender.circumstances && (
                        <Grid container spacing={3}>
                          {sectionToRender.circumstances.map((circumstance, idx) => (
                            <Grid item xs={12} md={4} key={idx}>
                              <Paper
                                elevation={2}
                                sx={{
                                  p: 3,
                                  height: '100%',
                                  borderTop: `4px solid ${circumstance.color}`,
                                  display: 'flex',
                                  flexDirection: 'column'
                                }}
                              >
                                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                                  {getIcon(circumstance.icon, { color: circumstance.color })}
                                  <Typography variant="h6" sx={{ ml: 1 }}>
                                    {circumstance.situation}
                                  </Typography>
                                </Box>
                                <List dense>
                                  {circumstance.guidelines.map((guideline, gIdx) => (
                                    <ListItem key={gIdx}>
                                      <ListItemIcon>
                                        <ArrowRight sx={{ color: circumstance.color }} />
                                      </ListItemIcon>
                                      <ListItemText primary={guideline} />
                                    </ListItem>
                                  ))}
                                </List>
                              </Paper>
                            </Grid>
                          ))}
                        </Grid>
                      )}

                      {/* Triggers Section */}
                      {key === 'triggers' && (
                        <Box>
                          <Typography variant="body1" sx={{ mb: 3 }}>
                            {sectionToRender.description}
                          </Typography>
                          <Grid container spacing={3}>
                            {sectionToRender.categories.map((category, idx) => (
                              <Grid item xs={12} sm={6} md={4} key={idx}>
                                <Paper
                                  elevation={2}
                                  sx={{
                                    p: 3,
                                    height: '100%',
                                    borderLeft: '4px solid #1976d2'
                                  }}
                                >
                                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                                    {getIcon(category.icon, { color: '#1976d2' })}
                                    <Typography variant="h6" sx={{ ml: 1 }}>
                                      {category.title}
                                    </Typography>
                                  </Box>
                                  {category.items ? (
                                    <List dense>
                                      {category.items.map((item, itemIdx) => (
                                        <ListItem key={itemIdx}>
                                          <ListItemIcon>
                                            <CircleIcon sx={{ fontSize: 'small', color: '#1976d2' }} />
                                          </ListItemIcon>
                                          <ListItemText primary={item} />
                                        </ListItem>
                                      ))}
                                    </List>
                                  ) : (
                                    <Typography variant="body2">
                                      {category.description}
                                    </Typography>
                                  )}
                                </Paper>
                              </Grid>
                            ))}
                          </Grid>
                        </Box>
                      )}

                      {/* Symptoms Section */}
                      {key === 'symptoms' && (
                        <Box>
                          <Typography variant="body1" sx={{ mb: 3 }}>
                            {sectionToRender.description}
                          </Typography>
                          <Grid container spacing={3}>
                            {sectionToRender.categories.map((category, idx) => (
                              <Grid item xs={12} md={6} key={idx}>
                                <Paper
                                  elevation={2}
                                  sx={{
                                    p: 3,
                                    height: '100%',
                                    borderLeft: `4px solid ${category.severity === 'error' ? '#f44336' : '#ff9800'}`
                                  }}
                                >
                                  <Typography variant="h6" sx={{ mb: 2, color: category.severity === 'error' ? '#f44336' : '#ff9800' }}>
                                    {category.system}
                                  </Typography>
                                  <List dense>
                                    {category.symptoms.map((symptom, sympIdx) => (
                                      <ListItem key={sympIdx}>
                                        <ListItemIcon>
                                          <WarningAmber sx={{ color: category.severity === 'error' ? '#f44336' : '#ff9800' }} />
                                        </ListItemIcon>
                                        <ListItemText primary={symptom} />
                                      </ListItem>
                                    ))}
                                  </List>
                                </Paper>
                              </Grid>
                            ))}
                          </Grid>
                        </Box>
                      )}

                      {/* Course Overview Section */}
                      {key === 'courseOverview' && (
                        <Box>
                          <Typography variant="body1" sx={{ mb: 3 }}>
                            {sectionToRender.description}
                          </Typography>
                          <Grid container spacing={3}>
                            {sectionToRender.modules.map((module, idx) => (
                              <Grid item xs={12} md={6} key={idx}>
                                <Paper
                                  elevation={2}
                                  sx={{
                                    p: 3,
                                    height: '100%',
                                    borderLeft: '4px solid #1976d2'
                                  }}
                                >
                                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                                    {getIcon(module.icon, { color: '#1976d2' })}
                                    <Typography variant="h6" sx={{ ml: 1 }}>
                                      {module.title}
                                    </Typography>
                                  </Box>
                                  <List dense>
                                    {module.keyPoints.map((point, pointIdx) => (
                                      <ListItem key={pointIdx}>
                                        <ListItemIcon>
                                          <CircleIcon sx={{ fontSize: 'small', color: '#1976d2' }} />
                                        </ListItemIcon>
                                        <ListItemText primary={point} />
                                      </ListItem>
                                    ))}
                                  </List>
                                </Paper>
                              </Grid>
                            ))}
                          </Grid>
                        </Box>
                      )}

                      {/* Critical Skills Section */}
                      {key === 'criticalSkills' && (
                        <Box>
                          <Typography variant="body1" sx={{ mb: 3 }}>
                            {sectionToRender.description}
                          </Typography>
                          <Grid container spacing={3}>
                            {sectionToRender.skills.map((skill, idx) => (
                              <Grid item xs={12} md={6} key={idx}>
                                <Paper
                                  elevation={2}
                                  sx={{
                                    p: 3,
                                    height: '100%',
                                    borderLeft: '4px solid #4caf50'
                                  }}
                                >
                                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                                    {getIcon(skill.icon, { color: '#4caf50' })}
                                    <Typography variant="h6" sx={{ ml: 1 }}>
                                      {skill.category}
                                    </Typography>
                                  </Box>
                                  <List dense>
                                    {skill.items.map((item, itemIdx) => (
                                      <ListItem key={itemIdx}>
                                        <ListItemIcon>
                                          <CheckCircle sx={{ fontSize: 'small', color: '#4caf50' }} />
                                        </ListItemIcon>
                                        <ListItemText primary={item} />
                                      </ListItem>
                                    ))}
                                  </List>
                                </Paper>
                              </Grid>
                            ))}
                          </Grid>
                        </Box>
                      )}

                      {/* Next Steps Section */}
                      {key === 'nextSteps' && (
                        <Box>
                          <Grid container spacing={3}>
                            {sectionToRender.sections.map((section, idx) => (
                              <Grid item xs={12} md={4} key={idx}>
                                <Paper
                                  elevation={2}
                                  sx={{
                                    p: 3,
                                    height: '100%',
                                    borderTop: '4px solid #ff9800'
                                  }}
                                >
                                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                                    {getIcon(section.icon, { color: '#ff9800' })}
                                    <Typography variant="h6" sx={{ ml: 1 }}>
                                      {section.title}
                                    </Typography>
                                  </Box>
                                  <Typography variant="body1">
                                    {section.content}
                                  </Typography>
                                </Paper>
                              </Grid>
                            ))}
                          </Grid>
                        </Box>
                      )}

                      {/* Pocket Mask Section */}
                      {key === 'pocketMask' && (
                        <Box>
                          <Typography variant="body1" sx={{ mb: 3 }}>
                            {sectionToRender.content}
                          </Typography>
                          
                          {/* Components Section */}
                          {sectionToRender.components && sectionToRender.components.length > 0 && (
                            <Box mb={4}>
                              <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 2 }}>
                                Pocket Mask Components:
                              </Typography>
                              <List dense>
                                {sectionToRender.components.map((component, idx) => (
                                  <ListItem key={`component-${idx}`}>
                                    <ListItemIcon>
                                      <CircleIcon sx={{ fontSize: 'small', color: '#1976d2' }} />
                                    </ListItemIcon>
                                    <ListItemText primary={component} />
                                  </ListItem>
                                ))}
                              </List>
                            </Box>
                          )}
                          
                          {/* Steps Section */}
                          <Box mb={4}>
                            <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 2 }}>
                              Steps for Using a Pocket Mask:
                            </Typography>
                            <List dense>
                              {sectionToRender.steps?.map((step, idx) => (
                                <ListItem key={`step-${idx}`}>
                                  <ListItemText 
                                    primary={`${idx + 1}. ${step}`}
                                    sx={{ pl: 2 }}
                                  />
                                </ListItem>
                              ))}
                            </List>
                          </Box>
                          
                          {/* Tips Section */}
                          {sectionToRender.tips && sectionToRender.tips.length > 0 && (
                            <Box mb={4}>
                              <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 2 }}>
                                Helpful Tips:
                              </Typography>
                              <List dense>
                                {sectionToRender.tips?.map((tip, idx) => (
                                  <ListItem key={`tip-${idx}`}>
                                    <ListItemIcon>
                                      <LightbulbIcon sx={{ color: '#ffc107' }} />
                                    </ListItemIcon>
                                    <ListItemText primary={tip} />
                                  </ListItem>
                                ))}
                              </List>
                            </Box>
                          )}
                        </Box>
                      )}

                      {/* BVM Device Section */}
                      {key === 'bvmDevice' && (
                        <Box>
                          <Typography variant="body1" sx={{ mb: 3 }}>
                            {sectionToRender.content}
                          </Typography>
                          
                          <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 2 }}>
                            BVM Components:
                          </Typography>
                          <List dense>
                            {sectionToRender.components.map((component, idx) => (
                              <ListItem key={idx}>
                                <ListItemIcon>
                                  <CircleIcon sx={{ fontSize: 'small', color: '#1976d2' }} />
                                </ListItemIcon>
                                <ListItemText primary={component} />
                              </ListItem>
                            ))}
                          </List>
                          
                          {sectionToRender.technique && (
                            <Box mt={3}>
                              <Typography variant="h6" gutterBottom>
                                {sectionToRender.technique.onePersonTechnique.title}
                              </Typography>
                              <List dense>
                                {sectionToRender.technique?.onePersonTechnique?.steps?.map((step, idx) => (
                                  <ListItem key={`one-person-${idx}`}>
                                    <ListItemText 
                                      primary={`${idx + 1}. ${step}`}
                                      sx={{ pl: 2 }}
                                    />
                                  </ListItem>
                                ))}
                              </List>
                              
                              <Typography variant="h6" gutterBottom sx={{ mt: 2 }}>
                                {sectionToRender.technique.twoPersonTechnique.title}
                              </Typography>
                              <List dense>
                                {sectionToRender.technique?.twoPersonTechnique?.steps?.map((step, idx) => (
                                  <ListItem key={`two-person-${idx}`}>
                                    <ListItemText 
                                      primary={`${idx + 1}. ${step}`}
                                      sx={{ pl: 2 }}
                                    />
                                  </ListItem>
                                ))}
                              </List>
                              
                              <Typography variant="h6" gutterBottom sx={{ mt: 2 }}>
                                {sectionToRender.technique.ventilationParameters.title}
                              </Typography>
                              <List dense>
                                {sectionToRender.technique?.ventilationParameters?.parameters?.map((param, idx) => (
                                  <ListItem key={`param-${idx}`}>
                                    <ListItemText 
                                      primary={param}
                                      sx={{ pl: 2 }}
                                    />
                                  </ListItem>
                                ))}
                              </List>
                            </Box>
                          )}
                          
                          {sectionToRender.considerations && sectionToRender.id!='4.7'&&(
                            <Box mt={3}>
                              <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 2 }}>
                                Important Considerations:
                              </Typography>
                              <List dense>
                                {sectionToRender.considerations?.map((consideration, idx) => (
                                  <ListItem key={idx}>
                                    <ListItemIcon>
                                      <InfoIcon color="primary" />
                                    </ListItemIcon>
                                    <ListItemText primary={consideration} />
                                  </ListItem>
                                ))}
                              </List>
                            </Box>
                          )}
                        </Box>
                      )}
                      
                      {/* Common Challenges Section */}
                      {key === 'commonChallenges' && (
                        <Box>
                          <Grid container spacing={3}>
                            {sectionToRender.issues?.map((issue, idx) => (
                              <Grid item xs={12} sm={6} key={idx}>
                                <Paper
                                  elevation={2}
                                  sx={{
                                    p: 2,
                                    height: '100%',
                                    borderLeft: '4px solid #ff9800',
                                    backgroundColor: '#fff8e1'
                                  }}
                                >
                                  <Typography variant="subtitle2" sx={{ fontWeight: 600, color: '#e65100' }}>
                                    Problem: {issue.problem}
                                  </Typography>
                                  <Typography variant="body2" sx={{ mt: 1 }}>
                                    <strong>Solution:</strong> {issue.solution}
                                  </Typography>
                                </Paper>
                              </Grid>
                            ))}
                          </Grid>
                        </Box>
                      )}
                      
                      {/* Safety Precautions Section */}
                      {key === 'safetyPrecautions' && (
                        <Box>
                          <List dense>
                            {sectionToRender.points?.map((point, idx) => (
                              <ListItem key={idx}>
                                <ListItemIcon>
                                  <SecurityIcon color="primary" />
                                </ListItemIcon>
                                <ListItemText primary={point} />
                              </ListItem>
                            ))}
                          </List>
                        </Box>
                      )}

                      {/* Treatment Section */}
                      {key === 'treatment' && (
                        <Box>
                          <Typography variant="h6" sx={{ mb: 3, color: '#1976d2' }}>
                            {sectionToRender.title}
                          </Typography>
                          {sectionToRender.sections.map((section, idx) => (
                            <Paper
                              key={idx}
                              elevation={2}
                              sx={{
                                p: 3,
                                mb: 2,
                                borderLeft: '4px solid #1976d2'
                              }}
                            >
                              <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 600 }}>
                                {section.title}
                              </Typography>
                              <Typography variant="body1">
                                {section.content}
                              </Typography>
                            </Paper>
                          ))}
                        </Box>
                      )}

                      {/* Original Symptoms and Signs Section */}
                      {key === 'symptomsAndSigns' && (
                        <Box>
                          {sectionToRender.description && (
                            <Typography variant="body1" sx={{ mb: 3 }}>
                              {sectionToRender.description}
                            </Typography>
                          )}
                          
                          {/* Progressive Signs */}
                          {sectionToRender.progressiveSigns && (
                            <Box sx={{ mb: 4 }}>
                              <Typography variant="h6" sx={{ mb: 2, color: '#1976d2' }}>
                                Progressive Signs of Choking
                              </Typography>
                              <Timeline>
                                {sectionToRender.progressiveSigns.map((sign, idx) => (
                                  <TimelineItem key={idx}>
                                    <TimelineSeparator>
                                      <TimelineDot color={{
                                        'Initial response': 'info',
                                        'Moderate': 'warning',
                                        'Severe': 'error',
                                        'Critical': 'error',
                                        'Life-threatening': 'error'
                                      }[sign.severity] || 'grey'} />
                                      {idx < sectionToRender.progressiveSigns.length - 1 && <TimelineConnector />}
                                    </TimelineSeparator>
                                    <TimelineContent>
                                      <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>
                                        {sign.sign}
                                      </Typography>
                                      <Typography variant="body2" color="text.secondary">
                                        Severity: {sign.severity}
                                      </Typography>
                                    </TimelineContent>
                                  </TimelineItem>
                                ))}
                              </Timeline>
                            </Box>
                          )}

                          {/* Additional Signs */}
                          {sectionToRender.additionalSigns && (
                            <Box>
                              <Typography variant="h6" sx={{ mb: 2, color: '#1976d2' }}>
                                Additional Signs
                              </Typography>
                              <Grid container spacing={3}>
                                {sectionToRender.additionalSigns.map((sign, idx) => (
                                  <Grid item xs={12} sm={4} key={idx}>
                                    <Paper
                                      elevation={2}
                                      sx={{
                                        p: 2,
                                        height: '100%',
                                        borderLeft: '4px solid #1976d2'
                                      }}
                                    >
                                      <Typography variant="subtitle1" sx={{ fontWeight: 500, mb: 1 }}>
                                        {sign.type}
                                      </Typography>
                                      <Typography variant="body2">
                                        {sign.description}
                                      </Typography>
                                    </Paper>
                                  </Grid>
                                ))}
                              </Grid>
                            </Box>
                          )}
                        </Box>
                      )}

                      {/* Airway Obstruction Types Section */}
                      {key === 'airwayObstructionTypes' && (
                        <Box>
                          <Typography variant="h6" sx={{ mb: 3, color: '#1976d2' }}>
                            {sectionToRender.title}
                          </Typography>
                          
                          <Grid container spacing={4}>
                            {/* Mild Obstruction */}
                            <Grid item xs={12} md={6}>
                              <Paper
                                elevation={2}
                                sx={{
                                  p: 3,
                                  height: '100%',
                                  borderLeft: '4px solid #4caf50'
                                }}
                              >
                                <Typography variant="h6" sx={{ mb: 2, color: '#4caf50' }}>
                                  {sectionToRender.mildObstruction.title}
                                </Typography>
                                <List>
                                  {sectionToRender.mildObstruction.signs.map((sign, idx) => (
                                    <ListItem key={idx}>
                                      <ListItemIcon>
                                        <CheckCircleOutline sx={{ color: '#4caf50' }} />
                                      </ListItemIcon>
                                      <ListItemText primary={sign} />
                                    </ListItem>
                                  ))}
                                </List>
                              </Paper>
                            </Grid>

                            {/* Severe Obstruction */}
                            <Grid item xs={12} md={6}>
                              <Paper
                                elevation={2}
                                sx={{
                                  p: 3,
                                  height: '100%',
                                  borderLeft: '4px solid #f44336'
                                }}
                              >
                                <Typography variant="h6" sx={{ mb: 2, color: '#f44336' }}>
                                  {sectionToRender.severeObstruction.title}
                                </Typography>
                                <List>
                                  {sectionToRender.severeObstruction.signs.map((sign, idx) => (
                                    <ListItem key={idx}>
                                      <ListItemIcon>
                                        <WarningAmber sx={{ color: '#f44336' }} />
                                      </ListItemIcon>
                                      <ListItemText primary={sign} />
                                    </ListItem>
                                  ))}
                                </List>
                              </Paper>
                            </Grid>
                          </Grid>
                        </Box>
                      )}

                      {/* Key Points Section */}
                      {key === 'keyPoints' && Array.isArray(sectionToRender) && (
                        <Paper
                          elevation={2}
                          sx={{
                            p: 3,
                            mb: 3,
                            borderRadius: 2,
                            borderLeft: '4px solid #ffa726',
                            backgroundColor: '#fff3e0'
                          }}
                        >
                          <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                            <LightbulbIcon sx={{ color: '#ffa726', mr: 1 }} />
                            <Typography variant="h6" sx={{ color: '#f57c00' }}>
                              Key Points to Remember
                            </Typography>
                          </Box>
                          <List>
                            {sectionToRender.map((point, idx) => (
                              <ListItem key={idx}>
                                <ListItemIcon>
                                  <StarIcon sx={{ color: '#ffa726' }} />
                                </ListItemIcon>
                                <ListItemText 
                                  primary={point}
                                  primaryTypographyProps={{
                                    sx: { fontWeight: 500 }
                                  }}
                                />
                              </ListItem>
                            ))}
                          </List>
                        </Paper>
                      )}

                      {/* BLS Sequence Section - Removed duplicate rendering */}

                      {/* Algorithm Section */}
                      {key === 'algorithm' && (
                        <Box sx={{ mb: 4 }}>
                          <Typography variant="h6" sx={{ mb: 2, color: '#1976d2' }}>
                            {/* {sectionToRender.title} */}
                          </Typography>
                          <Typography variant="body1" sx={{ mb: 3 }}>
                            {/* {sectionToRender.description} */}
                          </Typography>
                          
                          {sectionToRender.steps.map((step, stepIdx) => (
                            <Box key={stepIdx} sx={{ mb: 4 }}>
                              <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                                {step.title}
                              </Typography>
                              <Typography variant="body2" sx={{ mb: 2 }}>
                                {step.description}
                              </Typography>
                              
                              <Grid container spacing={3}>
                                {step.branches.map((branch, branchIdx) => (
                                  <Grid item xs={12} md={6} key={branchIdx}>
                                    <Paper
                                      elevation={2}
                                      sx={{
                                        p: 3,
                                        height: '100%',
                                        borderLeft: `4px solid ${branch.condition.includes('Severe') ? '#f44336' : '#4caf50'}`
                                      }}
                                    >
                                      <Typography variant="subtitle1" sx={{ fontWeight: 600, color: branch.condition.includes('Severe') ? '#f44336' : '#4caf50' }}>
                                        {branch.condition}
                                      </Typography>
                                      <Typography variant="body2" sx={{ mb: 2 }}>
                                        {branch.description}
                                      </Typography>
                                      
                                      {branch.outcomes ? (
                                        <List>
                                          {branch.outcomes.map((outcome, idx) => (
                                            <ListItem key={idx}>
                                              <ListItemIcon>
                                                <ArrowRight sx={{ color: branch.condition.includes('Severe') ? '#f44336' : '#4caf50' }} />
                                              </ListItemIcon>
                                              <ListItemText
                                                primary={outcome.state}
                                                secondary={outcome.action}
                                              />
                                            </ListItem>
                                          ))}
                                        </List>
                                      ) : (
                                        <Typography variant="body2">
                                          {branch.action}
                                        </Typography>
                                      )}
                                    </Paper>
                                  </Grid>
                                ))}
                              </Grid>
                            </Box>
                          ))}
                        </Box>
                      )}

                      {/* Procedures Section */}
                      {key === 'procedures' && (
                        <Box sx={{ mb: 4 }}>
                          {/* Back Blows */}
                          <Paper elevation={2} sx={{ p: 3, mb: 3, borderRadius: 2, borderLeft: '4px solid #1976d2' }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                              <PanToolIcon sx={{ color: '#1976d2', mr: 1 }} />
                              <Typography variant="h6" sx={{ color: '#1976d2' }}>
                                {sectionToRender.backBlows.title}
                              </Typography>
                            </Box>
                            <List>
                              {sectionToRender.backBlows.steps.map((step, idx) => (
                                <ListItem key={idx}>
                                  <ListItemIcon>
                                    <ArrowRight sx={{ color: '#1976d2' }} />
                                  </ListItemIcon>
                                  <ListItemText primary={step} />
                                </ListItem>
                              ))}
                            </List>
                          </Paper>

                          {/* Abdominal Thrusts */}
                          <Paper elevation={2} sx={{ p: 3, mb: 3 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                              <FitnessCenterIcon sx={{ color: '#1976d2', mr: 1 }} />
                              <Typography variant="h6">
                                {sectionToRender.abdominalThrusts.title}
                              </Typography>
                            </Box>
                            <List>
                              {sectionToRender.abdominalThrusts.steps.map((step, idx) => (
                                <ListItem key={idx}>
                                  <ListItemIcon>
                                    <ArrowRight sx={{ color: '#1976d2' }} />
                                  </ListItemIcon>
                                  <ListItemText primary={step} />
                                </ListItem>
                              ))}
                            </List>
                          </Paper>
                        </Box>
                      )}

                      {/* Legal Framework Section */}
                      {key === 'legalFramework' && (
                        <Box sx={{ mb: 4 }}>
                          <Typography variant="h6" sx={{ mb: 3, color: '#1976d2' }}>
                            {/* {sectionToRender.title} */}
                          </Typography>
                          <Typography variant="body1" sx={{ mb: 3 }}>
                            {/* {sectionToRender.content} */}
                          </Typography>
                          <Grid container spacing={3}>
                            {sectionToRender.keyComponents.map((component, idx) => (
                              <Grid item xs={12} md={4} key={idx}>
                                <Paper
                                  elevation={2}
                                  sx={{
                                    p: 3,
                                    height: '100%',
                                    borderLeft: '4px solid #1976d2'
                                  }}
                                >
                                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                                    {getIcon('Gavel', { color: '#1976d2' })}
                                    <Typography variant="subtitle1" sx={{ ml: 2, fontWeight: 600 }}>
                                      {component.component}
                                    </Typography>
                                  </Box>
                                  <Typography variant="body2">
                                    {component.description}
                                  </Typography>
                                </Paper>
                              </Grid>
                            ))}
                          </Grid>
                        </Box>
                      )}

                      {/* Liability and Documentation Section */}
                      {key === 'liabilityAndDocumentation' && (
                        <Box sx={{ mb: 4 }}>
                          <Typography variant="h6" sx={{ mb: 3, color: '#f44336' }}>
                            {/* {sectionToRender.title} */}
                          </Typography>
                          <Typography variant="body1" sx={{ mb: 3 }}>
                            {/* {sectionToRender.content} */}
                          </Typography>
                          <Grid container spacing={3}>
                            {sectionToRender.keyPoints.map((point, idx) => (
                              <Grid item xs={12} md={6} key={idx}>
                                <Paper
                                  elevation={2}
                                  sx={{
                                    p: 3,
                                    height: '100%',
                                    borderLeft: '4px solid #f44336'
                                  }}
                                >
                                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                                    {getIcon('Description', { color: '#f44336' })}
                                    <Typography variant="subtitle1" sx={{ ml: 2, fontWeight: 600 }}>
                                      {point.point}
                                    </Typography>
                                  </Box>
                                  <Typography variant="body2">
                                    {point.description}
                                  </Typography>
                                </Paper>
                              </Grid>
                            ))}
                          </Grid>
                        </Box>
                      )}

                      {/* Ethical Considerations Section - Removed
                      {/* {key === 'ethicalConsiderations' && (
                        <Box sx={{ mb: 4 }}>
                          <Typography variant="h6" sx={{ mb: 3, color: '#4caf50' }}>
                            {sectionToRender.title}
                          </Typography>
                          <Grid container spacing={3}>
                            {sectionToRender.principles.map((principle, idx) => (
                              <Grid item xs={12} md={4} key={idx}>
                                <Paper
                                  elevation={2}
                                  sx={{
                                    p: 3,
                                    height: '100%',
                                    borderLeft: '4px solid #4caf50'
                                  }}
                                >
                                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                                    {getIcon('AccountBalance', { color: '#4caf50' })}
                                    <Typography variant="subtitle1" sx={{ ml: 2, fontWeight: 600 }}>
                                      {principle.name}
                                    </Typography>
                                  </Box>
                                  <Typography variant="body2">
                                    {principle.description}
                                  </Typography>
                                </Paper>
                              </Grid>
                            ))}
                          </Grid>
                        </Box>
                      )} */}

                      {/* Response Guidelines Section */}
                      {key === 'responseGuidelines' && (
                        <Box sx={{ mb: 4 }}>
                          <Typography variant="h6" sx={{ mb: 3, color: '#1976d2' }}>
                            {sectionToRender.title}
                          </Typography>
                          
                          {/* Main Sections */}
                          {sectionToRender.sections.map((section, sectionIdx) => (
                            <Paper
                              key={sectionIdx}
                              elevation={2}
                              sx={{
                                p: 3,
                                mb: 3,
                                borderRadius: 2,
                                borderLeft: '4px solid #1976d2'
                              }}
                            >
                              <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                                {sectionIdx === 0 ? (
                                  <AssessmentIcon sx={{ color: '#1976d2', mr: 1 }} />
                                ) : sectionIdx === 1 ? (
                                  <TouchAppIcon sx={{ color: '#1976d2', mr: 1 }} />
                                ) : (
                                  <MonitorHeartIcon sx={{ color: '#1976d2', mr: 1 }} />
                                )}
                                <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                                  {section.title}
                                </Typography>
                              </Box>
                              <List>
                                {section.steps.map((step, stepIdx) => (
                                  <ListItem key={stepIdx}>
                                    <ListItemIcon>
                                      <CircleIcon sx={{ color: '#1976d2', fontSize: '0.8rem' }} />
                                    </ListItemIcon>
                                    <ListItemText primary={step} />
                                  </ListItem>
                                ))}
                              </List>
                            </Paper>
                          ))}

                          {/* Special Considerations */}
                          <Paper
                            elevation={2}
                            sx={{
                              p: 3,
                              borderRadius: 2,
                              borderLeft: '4px solid #ff9800',
                              backgroundColor: '#fff3e0'
                            }}
                          >
                            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                              <InfoIcon sx={{ color: '#ff9800', mr: 1 }} />
                              <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                                Special Considerations
                              </Typography>
                            </Box>
                            <List>
                              {sectionToRender.specialConsiderations.map((consideration, idx) => (
                                <ListItem key={idx}>
                                  <ListItemIcon>
                                    <ArrowRight sx={{ color: '#ff9800' }} />
                                  </ListItemIcon>
                                  <ListItemText 
                                    primary={consideration}
                                    primaryTypographyProps={{
                                      sx: { fontWeight: 500 }
                                    }}
                                  />
                                </ListItem>
                              ))}
                            </List>
                          </Paper>
                        </Box>
                      )}

                      {/* Key Aspects Section */}
                      {key === 'keyAspects' && sectionToRender.aspects && (
                        <Grid container spacing={3}>
                          {sectionToRender.aspects.map((aspect, idx) => (
                            <Grid item xs={12} sm={6} key={idx}>
                              <Paper
                                elevation={2}
                                sx={{
                                  p: 3,
                                  height: '100%',
                                  borderLeft: `4px solid ${aspect.color}`,
                                  display: 'flex',
                                  flexDirection: 'column'
                                }}
                              >
                                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                                  {getIcon(aspect.icon, { sx: { color: aspect.color } })}
                                  <Typography variant="h6" sx={{ ml: 1, fontWeight: 600 }}>
                                    {aspect.title}
                                  </Typography>
                                </Box>
                                <Typography variant="body1" sx={{ mb: 2 }}>
                                  {aspect.description}
                                </Typography>
                                {aspect.details && (
                                  <List dense>
                                    {aspect.details.map((detail, dIdx) => (
                                      <ListItem key={dIdx}>
                                        <ListItemIcon>
                                          <ArrowRight sx={{ color: aspect.color }} />
                                        </ListItemIcon>
                                        <ListItemText primary={detail} />
                                      </ListItem>
                                    ))}
                                  </List>
                                )}
                              </Paper>
                            </Grid>
                          ))}
                        </Grid>
                      )}

                      {/* Patient Positioning Section */}
                      {key === 'patientPositioning' && sectionToRender.items && (
                        <>
                          {sectionToRender.description && (
                            <Typography variant="body1" sx={{ mb: 3 }}>
                              {sectionToRender.description}
                            </Typography>
                          )}
                          <Grid container spacing={3}>
                            {sectionToRender.items.map((item, idx) => (
                              <Grid item xs={12} sm={6} key={idx}>
                                <Paper
                                  elevation={2}
                                  sx={{
                                    p: 3,
                                    height: '100%',
                                    borderLeft: `4px solid ${item.color}`,
                                    display: 'flex',
                                    flexDirection: 'column'
                                  }}
                                >
                                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                                    {getIcon(item.icon, { sx: { color: item.color } })}
                                    <Typography variant="h6" sx={{ ml: 1, fontWeight: 600 }}>
                                      {item.title}
                                    </Typography>
                                  </Box>
                                  <Typography variant="body1">
                                    {item.description}
                                  </Typography>
                                </Paper>
                              </Grid>
                            ))}
                          </Grid>
                        </>
                      )}

                      {/* Communication and Handover Section */}
                      {key === 'communicationAndHandover' && sectionToRender.items && (
                        <>
                          {sectionToRender.description && (
                            <Typography variant="body1" sx={{ mb: 3 }}>
                              {sectionToRender.description}
                            </Typography>
                          )}
                          <Grid container spacing={3}>
                            {sectionToRender.items.map((item, idx) => (
                              <Grid item xs={12} sm={6} key={idx}>
                                <Paper
                                  elevation={2}
                                  sx={{
                                    p: 3,
                                    height: '100%',
                                    borderLeft: `4px solid ${item.color}`,
                                    display: 'flex',
                                    flexDirection: 'column'
                                  }}
                                >
                                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                                    {getIcon(item.icon, { sx: { color: item.color } })}
                                    <Typography variant="h6" sx={{ ml: 1, fontWeight: 600 }}>
                                      {item.title}
                                    </Typography>
                                  </Box>
                                  <Typography variant="body1">
                                    {item.description}
                                  </Typography>
                                </Paper>
                              </Grid>
                            ))}
                          </Grid>
                        </>
                      )}

                      {/* Overview Section */}
                      {key === 'overview' && sectionToRender.keyComponents && (
                        <>
                          <Typography variant="body1" sx={{ mb: 3 }}>
                            {sectionToRender.content}
                          </Typography>
                          <Grid container spacing={3}>
                            {sectionToRender.keyComponents.map((component, idx) => (
                              <Grid item xs={12} sm={6} md={4} key={idx}>
                                <Paper
                                  elevation={2}
                                  sx={{
                                    p: 2,
                                    height: '100%',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    borderLeft: `4px solid ${component.color}`
                                  }}
                                >
                                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                    {getIcon(component.icon, { sx: { color: component.color } })}
                                    <Typography variant="subtitle1" sx={{ ml: 1, fontWeight: 600 }}>
                                      {component.name}
                                    </Typography>
                                  </Box>
                                  <Typography variant="body2">
                                    {component.description}
                                  </Typography>
                                </Paper>
                              </Grid>
                            ))}
                          </Grid>
                        </>
                      )}

                      {/* Essential Components Section */}
                      {key === 'essentialParts' && sectionToRender.parts && (
                        <>
                          <Typography variant="body1" sx={{ mb: 3 }}>
                            {sectionToRender.description}
                          </Typography>
                          <Grid container spacing={3}>
                            {sectionToRender.parts.map((part, idx) => (
                              <Grid item xs={12} md={4} key={idx}>
                                <Paper
                                  elevation={3}
                                  sx={{
                                    p: 3,
                                    height: '100%',
                                    borderTop: `4px solid ${part.details.color}`,
                                    display: 'flex',
                                    flexDirection: 'column'
                                  }}
                                >
                                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                                    {getIcon(part.details.icon, { sx: { color: part.details.color, fontSize: 'medium' } })}
                                    <Typography variant="h6" sx={{ ml: 1 }}>
                                      {part.name}
                                    </Typography>
                                  </Box>
                                  
                                  <Typography variant="body2" sx={{ mb: 2 }}>
                                    {part.details.description}
                                  </Typography>

                                  <Typography variant="subtitle2" color="primary" sx={{ mb: 1 }}>
                                    Key Features:
                                  </Typography>
                                  <List dense sx={{ mb: 2 }}>
                                    {part.details.features.map((feature, fIdx) => (
                                      <ListItem key={fIdx} sx={{ py: 0.5 }}>
                                        <ListItemIcon>
                                          <ArrowRight sx={{ color: part.details.color }} />
                                        </ListItemIcon>
                                        <ListItemText primary={feature} />
                                      </ListItem>
                                    ))}
                                  </List>

                                  <Box sx={{ mt: 'auto', pt: 2, borderTop: '1px solid rgba(0,0,0,0.1)' }}>
                                    <Typography variant="caption" color="text.secondary">
                                      Maintenance: {part.details.maintenance}
                                    </Typography>
                                  </Box>
                                </Paper>
                              </Grid>
                            ))}
                          </Grid>
                        </>
                      )}

                      {/* AED Preparation Steps */}
                      {key === 'preparation' && sectionToRender.steps && (
                        <Grid container spacing={3}>
                          {sectionToRender.steps.map((step, idx) => (
                            <Grid item xs={12} sm={6} key={idx}>
                              <Paper
                                elevation={2}
                                sx={{
                                  p: 3,
                                  height: '100%',
                                  borderLeft: `4px solid ${step.color}`,
                                  display: 'flex',
                                  flexDirection: 'column'
                                }}
                              >
                                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                                  {getIcon(step.icon, { sx: { color: step.color } })}
                                  <Typography variant="h6" sx={{ ml: 1 }}>
                                    {step.title}
                                  </Typography>
                                </Box>
                                <Typography variant="body1">{step.description}</Typography>
                              </Paper>
                            </Grid>
                          ))}
                        </Grid>
                      )}

                      {/* Chest Preparation Steps */}
                      {key === 'chestPreparation' && sectionToRender.steps && (
                        <>
                          <Typography variant="body1" sx={{ mb: 3 }}>
                            {sectionToRender.description}
                          </Typography>
                          <Grid container spacing={3}>
                            {sectionToRender.steps.map((step, idx) => (
                              <Grid item xs={12} sm={6} md={4} key={idx}>
                                <Paper
                                  elevation={2}
                                  sx={{
                                    p: 2,
                                    height: '100%',
                                    borderLeft: `4px solid ${step.color}`,
                                    display: 'flex',
                                    flexDirection: 'column'
                                  }}
                                >
                                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                    {getIcon(step.icon, { sx: { color: step.color } })}
                                    <Typography variant="subtitle1" sx={{ ml: 1, fontWeight: 600 }}>
                                      {step.title}
                                    </Typography>
                                  </Box>
                                  <Typography variant="body2">{step.details}</Typography>
                                </Paper>
                              </Grid>
                            ))}
                          </Grid>
                        </>
                      )}

                      {/* Pad Placement Section */}
                      {key === 'padPlacement' && sectionToRender.positions && (
                        <>
                          <Typography variant="body1" sx={{ mb: 3 }}>
                            {sectionToRender.description}
                          </Typography>
                          {/* Image rendering removed */}
                          <Grid container spacing={3}>
                            {sectionToRender.positions.map((position, idx) => (
                              <Grid item xs={12} sm={6} key={idx}>
                                <Paper
                                  elevation={2}
                                  sx={{
                                    p: 3,
                                    height: '100%',
                                    borderLeft: `4px solid ${position.color}`,
                                    display: 'flex',
                                    alignItems: 'flex-start'
                                  }}
                                >
                                  {getIcon(position.icon, { sx: { color: position.color, mr: 2, mt: 0.5 } })}
                                  <Box>
                                    <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1 }}>
                                      {position.pad}
                                    </Typography>
                                    <Typography variant="body2">{position.location}</Typography>
                                  </Box>
                                </Paper>
                              </Grid>
                            ))}
                          </Grid>
                        </>
                      )}

                      {/* Operation Steps */}
                      {key === 'operationSteps' && sectionToRender.steps && (
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                          {sectionToRender.steps.map((step, idx) => (
                            <Paper
                              key={idx}
                              elevation={2}
                              sx={{
                                p: 2,
                                display: 'flex',
                                alignItems: 'flex-start',
                                borderLeft: `4px solid ${step.color}`
                              }}
                            >
                              <Box
                                sx={{
                                  minWidth: 40,
                                  height: 40,
                                  borderRadius: '50%',
                                  backgroundColor: step.color,
                                  color: 'white',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  mr: 2
                                }}
                              >
                                {step.step}
                              </Box>
                              <Box sx={{ flex: 1 }}>
                                <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 0.5 }}>
                                  {step.action}
                                </Typography>
                                <Typography variant="body2">{step.description}</Typography>
                              </Box>
                              {getIcon(step.icon, { sx: { color: step.color, ml: 2 } })}
                            </Paper>
                          ))}
                        </Box>
                      )}

                      {/* Continued Care Section */}
                      {key === 'continuedCare' && sectionToRender.items && (
                        <Grid container spacing={3}>
                          {sectionToRender.items.map((item, idx) => (
                            <Grid item xs={12} sm={6} md={4} key={idx}>
                              <Paper
                                elevation={2}
                                sx={{
                                  p: 3,
                                  height: '100%',
                                  borderLeft: `4px solid ${item.color}`,
                                  display: 'flex',
                                  flexDirection: 'column'
                                }}
                              >
                                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                                  {getIcon(item.icon, { sx: { color: item.color } })}
                                  <Typography variant="h6" sx={{ ml: 1 }}>
                                    {item.title}
                                  </Typography>
                                </Box>
                                <Typography variant="body2">{item.description}</Typography>
                              </Paper>
                            </Grid>
                          ))}
                        </Grid>
                      )}

                      {/* Scene Assessment Section */}
                      {key === 'sceneAssessment' && sectionToRender.items && (
                        <>
                          <Typography variant="body1" sx={{ mb: 3 }}>
                            {sectionToRender.description}
                          </Typography>
                          <Grid container spacing={3}>
                            {sectionToRender.items.map((item, idx) => (
                              <Grid item xs={12} sm={6} key={idx}>
                                <Paper
                                  elevation={2}
                                  sx={{
                                    p: 3,
                                    height: '100%',
                                    borderLeft: `4px solid ${item.color}`,
                                    display: 'flex',
                                    flexDirection: 'column'
                                  }}
                                >
                                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                                    {getIcon(item.icon, { sx: { color: item.color } })}
                                    <Typography variant="h6" sx={{ ml: 1 }}>
                                      {item.title}
                                    </Typography>
                                  </Box>
                                  <Typography variant="body1">{item.description}</Typography>
                                </Paper>
                              </Grid>
                            ))}
                          </Grid>
                        </>
                      )}

                      {/* Technique Safety Section */}
                      {key === 'techniqueSafety' && sectionToRender.techniques && (
                        <>
                          <Typography variant="body1" sx={{ mb: 3 }}>
                            {sectionToRender.description}
                          </Typography>
                          <Grid container spacing={3}>
                            {sectionToRender.techniques.map((technique, idx) => (
                              <Grid item xs={12} sm={6} key={idx}>
                                <Paper
                                  elevation={2}
                                  sx={{
                                    p: 3,
                                    height: '100%',
                                    borderLeft: `4px solid ${technique.color}`,
                                    display: 'flex',
                                    flexDirection: 'column'
                                  }}
                                >
                                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                                    {getIcon(technique.icon, { sx: { color: technique.color } })}
                                    <Typography variant="h6" sx={{ ml: 1 }}>
                                      {technique.title}
                                    </Typography>
                                  </Box>
                                  <Typography variant="body1" sx={{ mb: 1 }}>{technique.description}</Typography>
                                  {technique.emphasis && (
                                    <Typography variant="subtitle2" sx={{ color: technique.color, fontWeight: 600 }}>
                                      {technique.emphasis}
                                    </Typography>
                                  )}
                                </Paper>
                              </Grid>
                            ))}
                          </Grid>
                        </>
                      )}

                      {/* Equipment Safety Section */}
                      {key === 'equipmentSafety' && sectionToRender.items && (
                        <Grid container spacing={3}>
                          {sectionToRender.items.map((item, idx) => (
                            <Grid item xs={12} sm={6} key={idx}>
                              <Paper
                                elevation={2}
                                sx={{
                                  p: 3,
                                  height: '100%',
                                  borderLeft: `4px solid ${item.color}`,
                                  display: 'flex',
                                  flexDirection: 'column'
                                }}
                              >
                                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                                  {getIcon(item.icon, { sx: { color: item.color } })}
                                  <Typography variant="h6" sx={{ ml: 1 }}>
                                    {item.title}
                                  </Typography>
                                </Box>
                                <Typography variant="body1">{item.description}</Typography>
                              </Paper>
                            </Grid>
                          ))}
                        </Grid>
                      )}

                      {/* Infection Control Section */}
                      {key === 'infectionControl' && sectionToRender.measures && (
                        <>
                          <Typography variant="body1" sx={{ mb: 3 }}>
                            {sectionToRender.description}
                          </Typography>
                          <Grid container spacing={3}>
                            {sectionToRender.measures.map((measure, idx) => (
                              <Grid item xs={12} sm={6} key={idx}>
                                <Paper
                                  elevation={2}
                                  sx={{
                                    p: 3,
                                    height: '100%',
                                    borderLeft: `4px solid ${measure.color}`,
                                    display: 'flex',
                                    flexDirection: 'column'
                                  }}
                                >
                                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                                    {getIcon(measure.icon, { sx: { color: measure.color } })}
                                    <Typography variant="h6" sx={{ ml: 1 }}>
                                      {measure.title}
                                    </Typography>
                                  </Box>
                                  <Typography variant="body1">{measure.description}</Typography>
                                </Paper>
                              </Grid>
                            ))}
                          </Grid>
                        </>
                      )}

                      {/* Additional Resources Section */}
                      {key === 'additionalResources' && sectionToRender.resources && (
                        <Grid container spacing={3}>
                          {sectionToRender.resources.map((resource, idx) => (
                            <Grid item xs={12} sm={6} key={idx}>
                              <Paper
                                elevation={2}
                                sx={{
                                  p: 3,
                                  height: '100%',
                                  borderLeft: `4px solid ${resource.color}`,
                                  display: 'flex',
                                  flexDirection: 'column'
                                }}
                              >
                                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                                  {getIcon(resource.icon, { sx: { color: resource.color } })}
                                  <Typography variant="h6" sx={{ ml: 1 }}>
                                    {resource.title}
                                  </Typography>
                                </Box>
                                <Typography variant="body1" sx={{ mb: 2 }}>{resource.description}</Typography>
                                <Button
                                  variant="outlined"
                                  color="primary"
                                  size="small"
                                  sx={{ alignSelf: 'flex-start' }}
                                >
                                  {resource.link}
                                </Button>
                              </Paper>
                            </Grid>
                          ))}
                        </Grid>
                      )}

                      {/* Additional Items Section */}
                      {key === 'additionalItems' && sectionToRender.items && (
                        <>
                          <Typography variant="body1" sx={{ mb: 3 }}>
                            {sectionToRender.description}
                          </Typography>
                          <Grid container spacing={3}>
                            {sectionToRender.items.map((item, idx) => (
                              <Grid item xs={12} sm={6} md={4} key={idx}>
                                <Paper
                                  elevation={2}
                                  sx={{
                                    p: 2,
                                    height: '100%',
                                    display: 'flex',
                                    alignItems: 'center',
                                    borderRadius: 2,
                                    border: `1px solid ${item.color}`
                                  }}
                                >
                                  <Box sx={{ mr: 2 }}>
                                    {getIcon(item.icon, { sx: { color: item.color, fontSize: 'large' } })}
                                  </Box>
                                  <Box>
                                    <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                                      {item.name}
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary">
                                      {item.description}
                                    </Typography>
                                  </Box>
                                </Paper>
                              </Grid>
                            ))}
                          </Grid>
                        </>
                      )}

                      {/* Maintenance Section */}
                      {key === 'maintenance' && sectionToRender.checkList && (
                        <Grid container spacing={3}>
                          {sectionToRender.checkList.map((item, idx) => (
                            <Grid item xs={12} sm={6} md={3} key={idx}>
                              <Paper
                                elevation={2}
                                sx={{
                                  p: 2,
                                  height: '100%',
                                  borderRadius: 2,
                                  border: `1px solid ${item.color}`,
                                  display: 'flex',
                                  flexDirection: 'column'
                                }}
                              >
                                <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                  {getIcon(item.icon, { color: item.color })}
                                  <Box sx={{ ml: 1 }}>
                                    <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                                      {item.task}
                                    </Typography>
                                    <Typography variant="caption" color="text.secondary">
                                      {item.frequency}
                                    </Typography>
                                  </Box>
                                </Box>
                                <Typography variant="body2" sx={{ mt: 1 }}>
                                  {item.description}
                                </Typography>
                              </Paper>
                            </Grid>
                          ))}
                        </Grid>
                      )}

                      {/* Key Components */}
                      {key === 'primaryPurpose' && section.keyComponents && (
                        <List>
                          {section.keyComponents.map((item, index) => (
                            <ListItem 
                              key={index}
                              sx={{
                                bgcolor: 'background.paper',
                                borderRadius: 2,
                                mb: 3,
                                p: 3,
                                boxShadow: 2,
                                borderLeft: '4px solid #1976d2'
                              }}
                            >
                              <ListItemText
                                primary={
                                  <Typography variant="h6" sx={{ mb: 1, color: '#1976d2', fontWeight: 600 }}>
                                    {item.component}
                                  </Typography>
                                }
                                secondary={
                                  <Typography variant="body1" sx={{ color: 'text.secondary' }}>
                                    {item.description}
                                  </Typography>
                                }
                              />
                            </ListItem>
                          ))}
                        </List>
                      )}
                      
                      {/* {section.keyComponents && key !== 'primaryPurpose' && (
                        <List>
                          {section.keyComponents.map((item, index) => (
                            <ListItem 
                              key={index}
                              sx={{
                                bgcolor: 'background.paper',
                                borderRadius: 1,
                                mb: 2,
                                boxShadow: 1
                              }}
                            >
                              <ListItemIcon>
                                <Box
                                  sx={{
                                    width: 32,
                                    height: 32,
                                    borderRadius: '50%',
                                    bgcolor: 'primary.main',
                                    color: 'white',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontWeight: 'bold',
                                    fontSize: '0.875rem'
                                  }}
                                >
                                  {index + 1}
                                </Box>
                              </ListItemIcon>
                              <ListItemText
                                primary={item.component}
                                secondary={item.description}
                                primaryTypographyProps={{
                                  fontWeight: 600,
                                  color: 'primary.main',
                                  gutterBottom: true
                                }}
                                secondaryTypographyProps={{
                                  sx: { lineHeight: 1.6 }
                                }}
                              />
                            </ListItem>
                          ))}
                        </List>
                      )} */}

                      {/* Cardiac Arrest Signs Section */}
                      {key === 'cardiacArrestSigns' && sectionToRender.symptoms && (
                        <Box>
                          <Typography variant="body1" sx={{ mb: 3 }}>
                            {sectionToRender.description}
                          </Typography>
                          <Grid container spacing={3}>
                            {sectionToRender.symptoms.map((symptom, idx) => (
                              <Grid item xs={12} md={6} key={idx}>
                                <Paper
                                  elevation={2}
                                  sx={{
                                    p: 3,
                                    height: '100%',
                                    borderLeft: `4px solid ${symptom.color}`,
                                    backgroundColor: symptom.severity === 'Critical' ? '#fef2f2' : '#f8fafc'
                                  }}
                                >
                                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                                    {getIcon(symptom.icon, { color: symptom.color })}
                                    <Box sx={{ ml: 1 }}>
                                      <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                                        {symptom.title}
                                      </Typography>
                                      <Typography variant="caption" sx={{ color: symptom.color }}>
                                        {symptom.severity} • {symptom.timeFrame}
                                      </Typography>
                                    </Box>
                                  </Box>
                                  <Typography variant="body2">
                                    {symptom.description}
                                  </Typography>
                                </Paper>
                              </Grid>
                            ))}
                          </Grid>
                        </Box>
                      )}

                      {/* Key Indicators */}
                      {/* Special Considerations Section */}
                      {sectionToRender.specialConsiderations && (
                        <Box sx={{ mb: 4 }}>
                          <Typography variant="h5" sx={{ mb: 3, color: 'primary.main', display: 'flex', alignItems: 'center', gap: 1 }}>
                            {/* <InfoIcon /> Special Considerations */}
                          </Typography>
                          {/* <Grid container spacing={3}>
                            {Object.entries(sectionToRender.specialConsiderations).map(([key, consideration], idx) => (
                              <Grid item xs={12} md={6} key={`consideration-${key}`}>
                                <Paper 
                                  elevation={2} 
                                  sx={{ 
                                    p: 3, 
                                    height: '100%',
                                    borderLeft: '4px solid',
                                    borderColor: 'primary.main',
                                    bgcolor: 'background.paper',
                                    transition: 'transform 0.2s',
                                    '&:hover': {
                                      transform: 'translateY(-2px)'
                                    }
                                  }}
                                >
                                  <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 2 }}>
                                    <Box sx={{ 
                                      bgcolor: 'primary.light', 
                                      color: 'primary.contrastText', 
                                      p: 1, 
                                      borderRadius: '50%',
                                      mr: 2,
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      minWidth: '36px',
                                      height: '36px'
                                    }}>
                                      {idx + 1}
                                    </Box>
                                    <Typography variant="h6" sx={{ mt: 0.5 }}>
                                      {consideration.title}
                                    </Typography>
                                  </Box>
                                  {consideration.description && (
                                    <Typography variant="body1" paragraph>
                                      {consideration.description}
                                    </Typography>
                                  )}
                                  {consideration.points && (
                                    <List dense disablePadding>
                                      {consideration.points.map((point, pointIdx) => (
                                        <ListItem key={`point-${key}-${pointIdx}`} disableGutters>
                                          <ListItemIcon sx={{ minWidth: 32 }}>
                                            <FiberManualRecordIcon sx={{ fontSize: 10, color: 'text.secondary' }} />
                                          </ListItemIcon>
                                          <ListItemText 
                                            primary={
                                              <Typography variant="body2">
                                                {point}
                                              </Typography>
                                            } 
                                          />
                                        </ListItem>
                                      ))}
                                    </List>
                                  )}
                                </Paper>
                              </Grid>
                            ))}
                          </Grid> */}
                        </Box>
                      )}

                      {/* Indicators Section */}
                      {sectionToRender.indicators && (
                        <List>
                          {sectionToRender.indicators.map((indicator, index) => {
                            const IndicatorIcon = {
                              'PersonOff': PersonIcon,
                              'NotInterested': ReportProblemIcon,
                              'AirOff': AirIcon
                            }[indicator.icon] || WarningIcon;

                            return (
                              <ListItem 
                                key={index}
                                sx={{
                                  bgcolor: 'background.paper',
                                  borderRadius: 2,
                                  mb: 3,
                                  p: 3,
                                  boxShadow: 2,
                                  borderLeft: `6px solid ${indicator.color || '#f44336'}`
                                }}
                              >
                                <ListItemIcon>
                                  <IndicatorIcon sx={{ color: indicator.color || '#f44336' }} />
                                </ListItemIcon>
                                <ListItemText
                                  primary={
                                    <Typography variant="h6" sx={{ color: indicator.color || '#f44336', mb: 1 }}>
                                      {indicator.title}
                                    </Typography>
                                  }
                                  secondary={
                                    <Typography variant="body1" sx={{ color: 'text.secondary' }}>
                                      {indicator.description}
                                    </Typography>
                                  }
                                />
                              </ListItem>
                            );
                          })}
                        </List>
                      )}

                      {/* Assessment Techniques Section */}
                      {key === 'assessmentTechniques' && sectionToRender.techniques && (
                        <Box sx={{ mb: 4 }}>
                          <Typography variant="body1" sx={{ mb: 3 }}>
                            {sectionToRender.description}
                          </Typography>
                          <Grid container spacing={3}>
                            {sectionToRender.techniques.map((technique, idx) => (
                              <Grid item xs={12} md={6} key={idx}>
                                <Paper
                                  elevation={2}
                                  sx={{
                                    p: 3,
                                    height: '100%',
                                    borderLeft: '4px solid #1976d2',
                                    backgroundColor: '#f5f9ff'
                                  }}
                                >
                                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                                    {getIcon(technique.icon, { color: '#1976d2' })}
                                    <Typography variant="subtitle1" sx={{ ml: 1, fontWeight: 600 }}>
                                      {technique.title}
                                    </Typography>
                                  </Box>
                                  <Typography variant="body2" sx={{ mb: 2 }}>
                                    {technique.description}
                                  </Typography>
                                  {technique.steps && (
                                    <List dense>
                                      {technique.steps.map((step, stepIdx) => (
                                        <ListItem key={stepIdx}>
                                          <ListItemIcon>
                                            <ArrowRightIcon sx={{ color: '#1976d2' }} />
                                          </ListItemIcon>
                                          <ListItemText primary={step} />
                                        </ListItem>
                                      ))}
                                    </List>
                                  )}
                                </Paper>
                              </Grid>
                            ))}
                          </Grid>
                        </Box>
                      )}

                      {/* Critical Decision Points Section */}
                      {key === 'criticalDecisions' && sectionToRender.decisions && (
                        <Box sx={{ mb: 4 }}>
                          <Typography variant="body1" sx={{ mb: 3 }}>
                            {sectionToRender.description}
                          </Typography>
                          <Grid container spacing={3}>
                            {sectionToRender.decisions.map((decision, idx) => (
                              <Grid item xs={12} key={idx}>
                                <Paper
                                  elevation={2}
                                  sx={{
                                    p: 3,
                                    borderLeft: `4px solid ${decision.color || '#1976d2'}`,
                                    backgroundColor: '#fafafa',
                                    mb: 2
                                  }}
                                >
                                  <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                                    <Box sx={{
                                      mr: 2,
                                      p: 1,
                                      borderRadius: '50%',
                                      bgcolor: decision.color || '#1976d2',
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center'
                                    }}>
                                      {getIcon(decision.icon, { color: '#ffffff' })}
                                    </Box>
                                    <Box>
                                      <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1 }}>
                                        {decision.scenario}
                                      </Typography>
                                      <Typography variant="body2">
                                        <strong>Action:</strong> {decision.action}
                                      </Typography>
                                    </Box>
                                  </Box>
                                </Paper>
                              </Grid>
                            ))}
                          </Grid>
                        </Box>
                      )}

                      {/* Compression Basics Section */}
                      {key === 'compressionBasics' && sectionToRender.keyComponents && (
                        <Box sx={{ mb: 4 }}>
                          <Typography variant="body1" sx={{ mb: 3 }}>
                            {sectionToRender.description}
                          </Typography>
                          <List>
                            {sectionToRender.keyComponents.map((item, index) => (
                              <ListItem 
                                key={index}
                                sx={{
                                  bgcolor: 'background.paper',
                                  borderRadius: 1,
                                  mb: 2,
                                  boxShadow: 1
                                }}
                              >
                                <ListItemIcon>
                                  <Box
                                    sx={{
                                      width: 32,
                                      height: 32,
                                      borderRadius: '50%',
                                      bgcolor: 'primary.main',
                                      color: 'white',
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      fontWeight: 'bold',
                                      fontSize: '0.875rem'
                                    }}
                                  >
                                    {index + 1}
                                  </Box>
                                </ListItemIcon>
                                <ListItemText
                                  primary={item.component}
                                  secondary={item.description}
                                  primaryTypographyProps={{
                                    fontWeight: 600,
                                    color: 'primary.main',
                                    gutterBottom: true
                                  }}
                                  secondaryTypographyProps={{
                                    sx: { lineHeight: 1.6 }
                                  }}
                                />
                              </ListItem>
                            ))}
                          </List>
                        </Box>
                      )}

                      {/* Common Errors Section */}
                      {key === 'commonErrors' && sectionToRender.errors && (
                        <Box sx={{ mb: 4 }}>
                          <Typography variant="body1" sx={{ mb: 3 }}>
                            {sectionToRender.description}
                          </Typography>
                          <Grid container spacing={3}>
                            {sectionToRender.errors.map((item, idx) => (
                              <Grid item xs={12} key={idx}>
                                <Paper
                                  elevation={2}
                                  sx={{
                                    p: 3,
                                    mb: 2,
                                    borderLeft: '4px solid #f44336'
                                  }}
                                >
                                  <Typography variant="subtitle1" sx={{ fontWeight: 600, color: '#d32f2f', mb: 1 }}>
                                    {item.error}
                                  </Typography>
                                  <Typography variant="body2" sx={{ mb: 2 }}>
                                    {item.description}
                                  </Typography>
                                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                    <CheckCircleOutline sx={{ color: '#4caf50', mr: 1 }} />
                                    <Typography variant="body2" sx={{ fontWeight: 500 }}>
                                      <strong>Correction:</strong> {item.correction}
                                    </Typography>
                                  </Box>
                                </Paper>
                              </Grid>
                            ))}
                          </Grid>
                        </Box>
                      )}

                      {/* Rescuer Fatigue Section */}
                      {key === 'rescuerFatigue' && sectionToRender.strategies && (
                        <Box sx={{ mb: 4 }}>
                          <Typography variant="body1" sx={{ mb: 3 }}>
                            {sectionToRender.description}
                          </Typography>
                          <Grid container spacing={3}>
                            {sectionToRender.strategies.map((item, idx) => (
                              <Grid item xs={12} md={6} key={idx}>
                                <Paper
                                  elevation={2}
                                  sx={{
                                    p: 3,
                                    height: '100%',
                                    borderLeft: '4px solid #2196f3'
                                  }}
                                >
                                  <Typography variant="subtitle1" sx={{ fontWeight: 600, color: '#1976d2', mb: 1 }}>
                                    {item.strategy}
                                  </Typography>
                                  <Typography variant="body2">
                                    {item.description}
                                  </Typography>
                                </Paper>
                              </Grid>
                            ))}
                          </Grid>
                        </Box>
                      )}

                      {/* Special Considerations Section */}
                      {key === 'specialConsiderations' && sectionToRender.considerations && (
                        <Grid container spacing={3}>
                          {sectionToRender.considerations.map((circumstance, idx) => (
                            <Grid item xs={12} md={4} key={idx}>
                              <Paper
                                elevation={2}
                                sx={{
                                  p: 3,
                                  height: '100%',
                                  borderTop: '4px solid #9c27b0',
                                  display: 'flex',
                                  flexDirection: 'column'
                                }}
                              >
                                <Typography variant="h6" sx={{ mb: 2 }}>
                                  {circumstance.situation}
                                </Typography>
                                <List dense>
                                  {circumstance.guidelines.map((guideline, gIdx) => (
                                    <ListItem key={gIdx}>
                                      <ListItemIcon>
                                        <ArrowRightIcon />
                                      </ListItemIcon>
                                      <ListItemText primary={guideline} />
                                    </ListItem>
                                  ))}
                                </List>
                              </Paper>
                            </Grid>
                          ))}
                        </Grid>
                      )}

                      {/* Airway Management Section */}
                      {key === 'airwayManagement' && sectionToRender.techniques && (
                        <Box sx={{ mb: 4 }}>
                          <Typography variant="body1" sx={{ mb: 3 }}>
                            {sectionToRender.description}
                          </Typography>
                          <Grid container spacing={3}>
                            {sectionToRender.techniques.map((item, idx) => (
                              <Grid item xs={12} key={idx}>
                                <Paper
                                  elevation={2}
                                  sx={{
                                    p: 3,
                                    mb: 2,
                                    borderLeft: '4px solid #3f51b5'
                                  }}
                                >
                                  <Typography variant="h6" sx={{ mb: 1 }}>
                                    {item.technique}
                                  </Typography>
                                  <Typography variant="body2" sx={{ mb: 2 }}>
                                    {item.description}
                                  </Typography>
                                  {item.steps && (
                                    <Box sx={{ ml: 2 }}>
                                      <Typography variant="subtitle2" sx={{ mb: 1 }}>
                                        Steps:
                                      </Typography>
                                      <List dense>
                                        {item.steps.map((step, stepIdx) => (
                                          <ListItem key={stepIdx}>
                                            <ListItemIcon>
                                              <Box
                                                sx={{
                                                  width: 24,
                                                  height: 24,
                                                  borderRadius: '50%',
                                                  bgcolor: 'primary.main',
                                                  color: 'white',
                                                  display: 'flex',
                                                  alignItems: 'center',
                                                  justifyContent: 'center',
                                                  fontSize: '0.75rem'
                                                }}
                                              >
                                                {stepIdx + 1}
                                              </Box>
                                            </ListItemIcon>
                                            <ListItemText primary={step} />
                                          </ListItem>
                                        ))}
                                      </List>
                                    </Box>
                                  )}
                                  {item.considerations && (
                                    <Box sx={{ mt: 2, bgcolor: '#f5f5f5', p: 2, borderRadius: 1 }}>
                                      <Typography variant="subtitle2" color="text.secondary">
                                        Note: {item.considerations}
                                      </Typography>
                                    </Box>
                                  )}
                                </Paper>
                              </Grid>
                            ))}
                          </Grid>
                        </Box>
                      )}

                      {/* Breath Delivery Section */}
                      {key === 'breathDelivery' && sectionToRender.steps && (
                        <Box sx={{ mb: 4 }}>
                          <Typography variant="body1" sx={{ mb: 3 }}>
                            {sectionToRender.description}
                          </Typography>
                          <Stepper orientation="vertical" sx={{ mb: 3 }}>
                            {sectionToRender.steps.map((item, index) => {
                              // Select the appropriate icon based on the step
                              let StepIcon;
                              switch(item.step) {
                                case 'Position Yourself':
                                  StepIcon = AccessibilityIcon;
                                  break;
                                case 'Open the Airway':
                                  StepIcon = HeadsetMicIcon;
                                  break;
                                case 'Pinch the Nose':
                                  StepIcon = PanToolIcon;
                                  break;
                                case 'Create a Seal':
                                  StepIcon = FaceIcon;
                                  break;
                                case 'Deliver the Breath':
                                  StepIcon = AirIcon;
                                  break;
                                case 'Allow Exhalation':
                                  StepIcon = LoopIcon;
                                  break;
                                case 'Repeat':
                                  StepIcon = RepeatIcon;
                                  break;
                                default:
                                  StepIcon = ArrowRightIcon;
                              }
                              
                              return (
                                <Step key={index} active={true}>
                                  <StepLabel
                                    StepIconComponent={StepIcon}
                                    StepIconProps={{
                                      sx: { color: 'primary.main' }
                                    }}
                                  >
                                    <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                                      {item.step}
                                    </Typography>
                                  </StepLabel>
                                  <StepContent>
                                    <Typography variant="body2">{item.description}</Typography>
                                  </StepContent>
                                </Step>
                              );
                            })}
                          </Stepper>
                          
                          {sectionToRender.keyPoints && (
                            <Paper
                              elevation={1}
                              sx={{
                                p: 3,
                                bgcolor: '#e3f2fd',
                                borderRadius: 2,
                                mt: 3
                              }}
                            >
                              <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 600 }}>
                                Key Points to Remember:
                              </Typography>
                              <List dense>
                                {sectionToRender.keyPoints.map((point, idx) => (
                                  <ListItem key={idx}>
                                    <ListItemIcon>
                                      <CheckCircleOutline color="primary" />
                                    </ListItemIcon>
                                    <ListItemText primary={point} />
                                  </ListItem>
                                ))}
                              </List>
                            </Paper>
                          )}
                        </Box>
                      )}

                      {/* Common Challenges Section */}
                      {key === 'commonChallenges' && sectionToRender.challenges && (
                        <Box sx={{ mb: 4 }}>
                          <Grid container spacing={3}>
                            {sectionToRender.challenges.map((item, idx) => (
                              <Grid item xs={12} key={idx}>
                                <Paper
                                  elevation={2}
                                  sx={{
                                    p: 0,
                                    mb: 2,
                                    overflow: 'hidden'
                                  }}
                                >
                                  <Box sx={{ bgcolor: '#ffebee', p: 2, borderBottom: '1px solid #ffcdd2' }}>
                                    <Typography variant="h6" sx={{ color: '#c62828' }}>
                                      {item.challenge}
                                    </Typography>
                                  </Box>
                                  <Box sx={{ p: 2 }}>
                                    <Grid container spacing={2}>
                                      <Grid item xs={12} md={6}>
                                        <Typography variant="subtitle2" sx={{ mb: 1, color: '#d32f2f' }}>
                                          Possible Causes:
                                        </Typography>
                                        <List dense>
                                          {item.causes.map((cause, causeIdx) => (
                                            <ListItem key={causeIdx}>
                                              <ListItemIcon>
                                                <ErrorOutline sx={{ color: '#f44336' }} />
                                              </ListItemIcon>
                                              <ListItemText primary={cause} />
                                            </ListItem>
                                          ))}
                                        </List>
                                      </Grid>
                                      <Grid item xs={12} md={6}>
                                        <Typography variant="subtitle2" sx={{ mb: 1, color: '#2e7d32' }}>
                                          Solutions:
                                        </Typography>
                                        <List dense>
                                          {item.solutions.map((solution, solIdx) => (
                                            <ListItem key={solIdx}>
                                              <ListItemIcon>
                                                <CheckCircleOutline sx={{ color: '#4caf50' }} />
                                              </ListItemIcon>
                                              <ListItemText primary={solution} />
                                            </ListItem>
                                          ))}
                                        </List>
                                      </Grid>
                                    </Grid>
                                  </Box>
                                </Paper>
                              </Grid>
                            ))}
                          </Grid>
                        </Box>
                      )}

                      {/* Barrier Devices Section */}
                      {key === 'barrierDevices' && sectionToRender.devices && (
                        <Box sx={{ mb: 4 }}>
                          <Typography variant="body1" sx={{ mb: 3 }}>
                            {sectionToRender.description}
                          </Typography>
                          <Grid container spacing={3}>
                            {sectionToRender.devices.map((item, idx) => (
                              <Grid item xs={12} md={6} key={idx}>
                                <Paper
                                  elevation={2}
                                  sx={{
                                    p: 3,
                                    height: '100%',
                                    borderTop: '4px solid #00897b'
                                  }}
                                >
                                  <Typography variant="h6" sx={{ mb: 2 }}>
                                    {item.device}
                                  </Typography>
                                  <Typography variant="body2" sx={{ mb: 2 }}>
                                    {item.description}
                                  </Typography>
                                  <Typography variant="subtitle2" sx={{ mb: 1 }}>
                                    How to Use:
                                  </Typography>
                                  <List dense>
                                    {item.usage.map((step, stepIdx) => (
                                      <ListItem key={stepIdx}>
                                        <ListItemIcon>
                                          <Box
                                            sx={{
                                              width: 24,
                                              height: 24,
                                              borderRadius: '50%',
                                              bgcolor: 'primary.main',
                                              color: 'white',
                                              display: 'flex',
                                              alignItems: 'center',
                                              justifyContent: 'center',
                                              fontSize: '0.75rem'
                                            }}
                                          >
                                            {stepIdx + 1}
                                          </Box>
                                        </ListItemIcon>
                                        <ListItemText primary={step} />
                                      </ListItem>
                                    ))}
                                  </List>
                                  <Box sx={{ mt: 2, bgcolor: '#e0f2f1', p: 2, borderRadius: 1 }}>
                                    <Typography variant="body2" color="text.secondary">
                                      <strong>Advantages:</strong> {item.advantages}
                                    </Typography>
                                  </Box>
                                </Paper>
                              </Grid>
                            ))}
                          </Grid>
                          {sectionToRender.safetyNote && (
                            <Alert severity="info" sx={{ mt: 3 }}>
                              {sectionToRender.safetyNote}
                            </Alert>
                          )}
                        </Box>
                      )}

                      {/* DRSABCD Approach Section */}
                      {key === 'drsabcdApproach' && sectionToRender.steps && (
                        <Box sx={{ mb: 4 }}>
                          <Typography variant="body1" sx={{ mb: 3 }}>
                            {sectionToRender.description}
                          </Typography>
                          <Timeline position="alternate">
                            {sectionToRender.steps.map((step, idx) => (
                              <TimelineItem key={idx}>
                                <TimelineSeparator>
                                  <TimelineDot sx={{ bgcolor: step.color || '#1976d2' }}>
                                    <Typography variant="h6" sx={{ color: 'white', fontWeight: 'bold' }}>
                                      {step.letter}
                                    </Typography>
                                  </TimelineDot>
                                  {idx < sectionToRender.steps.length - 1 && <TimelineConnector />}
                                </TimelineSeparator>
                                <TimelineContent>
                                  <Paper
                                    elevation={2}
                                    sx={{
                                      p: 3,
                                      borderLeft: `4px solid ${step.color || '#1976d2'}`,
                                      backgroundColor: '#fafafa'
                                    }}
                                  >
                                    <Typography variant="h6" sx={{ color: step.color || '#1976d2', fontWeight: 600 }}>
                                      {step.title}
                                    </Typography>
                                    <Typography variant="body1" sx={{ my: 1 }}>
                                      {step.description}
                                    </Typography>
                                    {step.actions && (
                                      <List dense>
                                        {step.actions.map((action, actionIdx) => (
                                          <ListItem key={actionIdx}>
                                            <ListItemIcon>
                                              <ArrowRightIcon sx={{ color: step.color || '#1976d2' }} />
                                            </ListItemIcon>
                                            <ListItemText primary={action} />
                                          </ListItem>
                                        ))}
                                      </List>
                                    )}
                                  </Paper>
                                </TimelineContent>
                              </TimelineItem>
                            ))}
                          </Timeline>
                        </Box>
                      )}

                      {/* CPR Ratios Section */}
                      {key === 'cprRatios' && sectionToRender.ageGroups && (
                        <Box sx={{ mb: 4 }}>
                          <Typography variant="body1" sx={{ mb: 3 }}>
                            {sectionToRender.description}
                          </Typography>
                          <Grid container spacing={3}>
                            {sectionToRender.ageGroups.map((group, idx) => (
                              <Grid item xs={12} sm={6} key={idx}>
                                <Paper
                                  elevation={2}
                                  sx={{
                                    p: 3,
                                    height: '100%',
                                    borderRadius: 2,
                                    border: '1px solid #1976d2',
                                    display: 'flex',
                                    flexDirection: 'column'
                                  }}
                                >
                                  <Typography variant="h6" color="primary" gutterBottom>
                                    {group.group}
                                  </Typography>
                                  
                                  <Box 
                                    sx={{ 
                                      bgcolor: 'primary.light', 
                                      color: 'white', 
                                      p: 1.5, 
                                      borderRadius: 1,
                                      display: 'inline-block',
                                      mb: 2,
                                      fontWeight: 'bold',
                                      fontSize: '1.2rem',
                                      textAlign: 'center'
                                    }}
                                  >
                                    Ratio: {group.ratio}
                                  </Box>
                                  
                                  <Typography variant="body2" paragraph>
                                    {group.description}
                                  </Typography>
                                  
                                  {group.notes && (
                                    <Alert severity="info" sx={{ mt: 'auto' }}>
                                      <Typography variant="body2">
                                        <strong>Note:</strong> {group.notes}
                                      </Typography>
                                    </Alert>
                                  )}
                                </Paper>
                              </Grid>
                            ))}
                          </Grid>
                        </Box>
                      )}
                      
                      {/* Compression Rate Section */}
                      {key === 'compressionRate' && sectionToRender.parameters && (
                        <Box sx={{ mb: 4 }}>
                          <Typography variant="body1" sx={{ mb: 3 }}>
                            {sectionToRender.description}
                          </Typography>
                          <Grid container spacing={3}>
                            {sectionToRender.parameters.map((param, idx) => (
                              <Grid item xs={12} key={idx}>
                                <Paper
                                  elevation={2}
                                  sx={{
                                    p: 3,
                                    borderRadius: 2,
                                    border: '1px solid #1976d2',
                                    mb: 2
                                  }}
                                >
                                  <Typography variant="h6" color="primary" gutterBottom>
                                    {param.parameter}
                                  </Typography>
                                  
                                  <Typography variant="body2" paragraph>
                                    {param.description}
                                  </Typography>
                                  
                                  {param.adult && (
                                    <Grid container spacing={2} sx={{ mt: 1 }}>
                                      <Grid item xs={12} sm={4}>
                                        <Paper 
                                          sx={{ 
                                            p: 2, 
                                            bgcolor: 'primary.light', 
                                            color: 'white',
                                            textAlign: 'center'
                                          }}
                                        >
                                          <Typography variant="subtitle2">Adult</Typography>
                                          <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                                            {param.adult}
                                          </Typography>
                                        </Paper>
                                      </Grid>
                                      
                                      <Grid item xs={12} sm={4}>
                                        <Paper 
                                          sx={{ 
                                            p: 2, 
                                            bgcolor: 'secondary.light',
                                            color: 'white',
                                            textAlign: 'center'
                                          }}
                                        >
                                          <Typography variant="subtitle2">Child</Typography>
                                          <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                                            {param.child}
                                          </Typography>
                                        </Paper>
                                      </Grid>
                                      
                                      <Grid item xs={12} sm={4}>
                                        <Paper 
                                          sx={{ 
                                            p: 2, 
                                            bgcolor: 'info.light',
                                            color: 'white',
                                            textAlign: 'center'
                                          }}
                                        >
                                          <Typography variant="subtitle2">Infant</Typography>
                                          <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                                            {param.infant}
                                          </Typography>
                                        </Paper>
                                      </Grid>
                                    </Grid>
                                  )}
                                  
                                  {param.target && (
                                    <Box sx={{ mt: 2 }}>
                                      <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                                        Target: 
                                      </Typography>
                                      <Typography variant="body2">
                                        {param.target}
                                      </Typography>
                                    </Box>
                                  )}
                                  
                                  {param.importance && (
                                    <Box sx={{ mt: 1 }}>
                                      <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                                        Importance: 
                                      </Typography>
                                      <Typography variant="body2">
                                        {param.importance}
                                      </Typography>
                                    </Box>
                                  )}
                                  
                                  {param.tip && (
                                    <Alert severity="success" sx={{ mt: 2 }}>
                                      <Typography variant="body2">
                                        <strong>Tip:</strong> {param.tip}
                                      </Typography>
                                    </Alert>
                                  )}
                                </Paper>
                              </Grid>
                            ))}
                          </Grid>
                        </Box>
                      )}
                      
                      {/* CPR Cycles Section */}
                      {key === 'cprCycles' && sectionToRender.cycles && (
                        <Box sx={{ mb: 4 }}>
                          <Typography variant="body1" sx={{ mb: 3 }}>
                            {sectionToRender.description}
                          </Typography>
                          <Grid container spacing={3}>
                            {sectionToRender.cycles.map((cycle, idx) => (
                              <Grid item xs={12} key={idx}>
                                <Paper
                                  elevation={2}
                                  sx={{
                                    p: 3,
                                    borderRadius: 2,
                                    border: '1px solid #1976d2',
                                    mb: 2
                                  }}
                                >
                                  <Typography variant="h6" color="primary" gutterBottom>
                                    {cycle.title}
                                  </Typography>
                                  
                                  <Typography variant="body2" paragraph>
                                    {cycle.description}
                                  </Typography>
                                  
                                  {cycle.keyPoints && (
                                    <Box sx={{ mt: 2 }}>
                                      <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                                        Key Points:
                                      </Typography>
                                      <List dense>
                                        {cycle.keyPoints.map((point, pointIdx) => (
                                          <ListItem key={pointIdx}>
                                            <ListItemIcon>
                                              <CheckCircleOutline fontSize="small" color="success" />
                                            </ListItemIcon>
                                            <ListItemText primary={point} />
                                          </ListItem>
                                        ))}
                                      </List>
                                    </Box>
                                  )}
                                  
                                  {cycle.when && (
                                    <Box sx={{ mt: 2 }}>
                                      <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                                        When to Check:
                                      </Typography>
                                      <List dense>
                                        {cycle.when.map((item, itemIdx) => (
                                          <ListItem key={itemIdx}>
                                            <ListItemIcon>
                                              <ArrowRightIcon color="primary" />
                                            </ListItemIcon>
                                            <ListItemText primary={item} />
                                          </ListItem>
                                        ))}
                                      </List>
                                    </Box>
                                  )}
                                  
                                  {cycle.steps && (
                                    <Box sx={{ mt: 2 }}>
                                      <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                                        Steps:
                                      </Typography>
                                      <List dense>
                                        {cycle.steps.map((step, stepIdx) => (
                                          <ListItem key={stepIdx}>
                                            <ListItemIcon>
                                              <ArrowRightIcon color="primary" />
                                            </ListItemIcon>
                                            <ListItemText primary={step} />
                                          </ListItem>
                                        ))}
                                      </List>
                                    </Box>
                                  )}
                                </Paper>
                              </Grid>
                            ))}
                          </Grid>
                        </Box>
                      )}
                      
                      {/* Special CPR Scenarios Section */}
                      {key === 'specialScenarios' && sectionToRender.scenarios && (
                        <Box sx={{ mb: 4 }}>
                          <Typography variant="body1" sx={{ mb: 3 }}>
                            {sectionToRender.description}
                          </Typography>
                          <Grid container spacing={3}>
                            {sectionToRender.scenarios.map((scenario, idx) => (
                              <Grid item xs={12} sm={6} key={idx}>
                                <Paper
                                  elevation={2}
                                  sx={{
                                    p: 3,
                                    height: '100%',
                                    borderRadius: 2,
                                    border: '1px solid #f57c00',
                                    bgcolor: 'rgba(245, 124, 0, 0.05)'
                                  }}
                                >
                                  <Typography variant="h6" color="warning.dark" gutterBottom>
                                    {scenario.scenario}
                                  </Typography>
                                  
                                  <Typography variant="subtitle2" sx={{ mt: 2, fontWeight: 600 }}>
                                    Adaptations:
                                  </Typography>
                                  <List dense>
                                    {scenario.adaptations.map((adaptation, adaptIdx) => (
                                      <ListItem key={adaptIdx}>
                                        <ListItemIcon>
                                          <ArrowRightIcon color="warning" />
                                        </ListItemIcon>
                                        <ListItemText primary={adaptation} />
                                      </ListItem>
                                    ))}
                                  </List>
                                </Paper>
                              </Grid>
                            ))}
                          </Grid>
                        </Box>
                      )}

                      {/* Safety Checklist Section */}
                      {key === 'safetyChecklist' && (
                        <Box sx={{ mb: 4 }}>
                          <Typography variant="h6" sx={{ mb: 3, color: '#2e7d32' }}>
                            {/* {sectionToRender.title} */}
                          </Typography>
                          <Typography variant="body1" sx={{ mb: 3 }}>
                            {/* {sectionToRender.content} */}
                          </Typography>
                          <Grid container spacing={3}>
                            {sectionToRender.checkpoints.map((checkpoint, idx) => (
                              <Grid item xs={12} md={6} key={idx}>
                                <Paper
                                  elevation={2}
                                  sx={{
                                    p: 3,
                                    height: '100%',
                                    borderLeft: '4px solid #2e7d32',
                                    backgroundColor: '#f1f8e9'
                                  }}
                                >
                                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                                    <CheckCircleIcon sx={{ color: '#2e7d32', mr: 1 }} />
                                    <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                                      {checkpoint.point}
                                    </Typography>
                                  </Box>
                                  <Typography variant="body2" color="text.secondary">
                                    {checkpoint.description}
                                  </Typography>
                                </Paper>
                              </Grid>
                            ))}
                          </Grid>
                        </Box>
                      )}

                      {/* Emergency Response Protocols */}
                      {sectionToRender.protocols && (
                        <Box>
                          <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary', fontSize: '1.1rem', lineHeight: 1.6 }}>
                            {sectionToRender.description}
                          </Typography>
                          <List>
                            {sectionToRender.protocols.map((protocol, index) => {
                              const ProtocolIcon = {
                                'Phone': PhoneIcon,
                                'Person': PersonIcon,
                                'Call': CallIcon
                              }[protocol.icon] || InfoIcon;

                              return (
                                <ListItem
                                  key={index}
                                  sx={{
                                    bgcolor: 'background.paper',
                                    borderRadius: 2,
                                    mb: 3,
                                    p: 3,
                                    boxShadow: 2,
                                    borderLeft: `6px solid ${protocol.color || '#1976d2'}`
                                  }}
                                >
                                  <ListItemIcon>
                                    <ProtocolIcon sx={{ color: protocol.color || '#1976d2' }} />
                                  </ListItemIcon>
                                  <ListItemText
                                    primary={
                                      <Typography variant="h6" sx={{ color: protocol.color || '#1976d2', mb: 1 }}>
                                        {protocol.scenario}
                                      </Typography>
                                    }
                                    secondary={
                                      <Typography variant="body1" sx={{ color: 'text.secondary' }}>
                                        {protocol.action}
                                      </Typography>
                                    }
                                  />
                                </ListItem>
                              );
                            })}
                          </List>
                        </Box>
                      )}

                      {/* Assessment Steps */}
                      {section.steps && section.title !== 'Primary Survey (ABCDE Approach)' && activeLesson.id !== '3.2' && activeLesson.id !== '4.2'&&activeLesson.id!='5.3' && activeLesson.id!='7.3' && activeLesson.id!='4.4'&&activeLesson.id!='4.4'&& activeLesson.id!='4.7' && (
                        <List>
                          {section.steps.map((step, index) => {
                            const StepIcon = {
                              'Visibility': VisibilityIcon,
                              'MonitorHeart': MonitorHeartIcon,
                              'TrackChanges': TrackChangesIcon,
                              'Assessment': AssessmentIcon,
                              'PriorityHigh': PriorityHighIcon
                            }[step.icon] || ArrowRight;
                            
                            return (
                              <ListItem 
                                key={index}
                                sx={{
                                  bgcolor: 'background.paper',
                                  borderRadius: 2,
                                  mb: 3,
                                  p: 3,
                                  boxShadow: 2,
                                  borderLeft: `6px solid ${step.color}`
                                }}
                              >
                                <ListItemIcon>
                                  <Box
                                    sx={{
                                      width: 40,
                                      height: 40,
                                      borderRadius: '50%',
                                      bgcolor: step.color,
                                      color: 'white',
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      fontWeight: 'bold',
                                      boxShadow: 1
                                    }}
                                  >
                                    <StepIcon />
                                  </Box>
                                </ListItemIcon>
                                <ListItemText
                                  primary={step.title}
                                  secondary={
                                    <>
                                      <Typography 
                                        component="div" 
                                        sx={{ 
                                          mt: 1,
                                          mb: step.details ? 2 : 0,
                                          color: 'text.primary',
                                          lineHeight: 1.6
                                        }}
                                      >
                                        {step.description}
                                      </Typography>
                                      {step.details && (
                                        <Typography 
                                          component="div"
                                          sx={{ 
                                            color: 'text.secondary',
                                            lineHeight: 1.6
                                          }}
                                        >
                                          {step.details}
                                        </Typography>
                                      )}
                                    </>
                                  }
                                  primaryTypographyProps={{
                                    variant: 'h6',
                                    sx: {
                                      fontWeight: 600,
                                      color: step.color,
                                      mb: 1
                                    }
                                  }}
                                />
                              </ListItem>
                            );
                          })}
                        </List>
                      )} 

                      {/* Warning Signs and Symptoms */}
                      {section.signs && (
                        <Box>
                          {section.signs.map((category, index) => (
                            <Paper
                              key={index}
                              sx={{
                                p: 3,
                                mb: 3,
                                borderRadius: 2,
                                borderLeft: '4px solid #1976d2'
                              }}
                            >
                              <Typography
                                variant="h6"
                                sx={{
                                  mb: 2,
                                  color: '#1976d2',
                                  fontWeight: 600
                                }}
                              >
                                {category.category}
                              </Typography>
                              {category.description && (
                                <Typography
                                  sx={{
                                    mb: 2,
                                    color: 'text.secondary',
                                    fontStyle: 'italic'
                                  }}
                                >
                                  {category.description}
                                </Typography>
                              )}
                              <List>
                                {category.indicators.map((indicator, idx) => (
                                  <ListItem
                                    key={idx}
                                    sx={{
                                      display: 'block',
                                      mb: 2,
                                      p: 2,
                                      bgcolor: 'background.paper',
                                      borderRadius: 1,
                                      boxShadow: 1
                                    }}
                                  >
                                    <Typography
                                      variant="subtitle1"
                                      sx={{
                                        fontWeight: 600,
                                        color: 'primary.main',
                                        mb: 1
                                      }}
                                    >
                                      {indicator.sign}
                                    </Typography>
                                    <Typography
                                      variant="body2"
                                      sx={{ color: 'text.secondary' }}
                                    >
                                      {indicator.details}
                                    </Typography>
                                  </ListItem>
                                ))}
                              </List>
                            </Paper>
                          ))}
                        </Box>
                      )}

                      {/* Cardiac and Non-Cardiac Causes */}
                      {section.causes && (
                        <List>
                          {section.causes.map((item, index) => (
                            <ListItem 
                              key={index}
                              sx={{
                                bgcolor: 'background.paper',
                                borderRadius: 1,
                                mb: 2,
                                boxShadow: 1
                              }}
                            >
                              <ListItemIcon>
                                <Box
                                  sx={{
                                    width: 32,
                                    height: 32,
                                    borderRadius: '50%',
                                    bgcolor: key === 'cardiacCauses' ? '#f44336' : '#2196f3',
                                    color: 'white',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontWeight: 'bold',
                                    fontSize: '0.875rem'
                                  }}
                                >
                                  {index + 1}
                                </Box>
                              </ListItemIcon>
                              <ListItemText
                                primary={item.name}
                                secondary={item.description}
                                primaryTypographyProps={{
                                  fontWeight: 600,
                                  color: key === 'cardiacCauses' ? '#f44336' : '#2196f3',
                                  gutterBottom: true
                                }}
                                secondaryTypographyProps={{
                                  sx: { lineHeight: 1.6 }
                                }}
                              />
                            </ListItem>
                          ))}
                        </List>
                      )}

                      {/* Key Differences */}
                      {section.comparisons && (
                        <List>
                          {section.comparisons.map((item, index) => (
                            <ListItem 
                              key={index}
                              sx={{
                                bgcolor: 'background.paper',
                                borderRadius: 1,
                                mb: 2,
                                boxShadow: 1
                              }}
                            >
                              <ListItemIcon>
                                <Box
                                  sx={{
                                    width: 32,
                                    height: 32,
                                    borderRadius: '50%',
                                    bgcolor: '#9c27b0',
                                    color: 'white',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontWeight: 'bold',
                                    fontSize: '0.875rem'
                                  }}
                                >
                                  {index + 1}
                                </Box>
                              </ListItemIcon>
                              <ListItemText
                                primary={item.condition}
                                secondary={item.description}
                                primaryTypographyProps={{
                                  fontWeight: 600,
                                  color: '#9c27b0',
                                  gutterBottom: true
                                }}
                                secondaryTypographyProps={{
                                  sx: { lineHeight: 1.6 }
                                }}
                              />
                            </ListItem>
                          ))}
                        </List>
                      )}

                      {/* Importance Factors */}
                      {section.factors && (
                        <List>
                          {section.factors.map((item, index) => (
                            <ListItem 
                              key={index}
                              sx={{
                                bgcolor: 'background.paper',
                                borderRadius: 1,
                                mb: 2,
                                boxShadow: 1
                              }}
                            >
                              <ListItemIcon>
                                <Box
                                  sx={{
                                    minWidth: 80,
                                    py: 0.5,
                                    px: 1,
                                    borderRadius: 1,
                                    bgcolor: item.importance === 'Critical' ? '#ef5350' :
                                             item.importance === 'High' ? '#fb8c00' :
                                             '#66bb6a',
                                    color: 'white',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontWeight: 'bold',
                                    fontSize: '0.75rem',
                                    margin:'20px'
                                  }}
                                >
                                  {item.importance}
                                </Box>
                              </ListItemIcon>
                              <ListItemText
                                primary={item.factor}
                                secondary={item.description}
                                primaryTypographyProps={{
                                  fontWeight: 600,
                                  color: 'primary.main',
                                  gutterBottom: true
                                }}
                                secondaryTypographyProps={{
                                  sx: { lineHeight: 1.6 }
                                }}
                              />
                            </ListItem>
                          ))}
                        </List>
                      )}

                      {/* Key Benefits */}
                      {section.benefits && (
                        <List>
                          {section.benefits.map((item, index) => (
                            <ListItem 
                              key={index}
                              sx={{
                                bgcolor: 'background.paper',
                                borderRadius: 1,
                                mb: 2,
                                boxShadow: 1
                              }}
                            >
                              <ListItemIcon>
                                <Box
                                  sx={{
                                    width: 40,
                                    height: 40,
                                    borderRadius: '50%',
                                    bgcolor: '#4caf50',
                                    color: 'white',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                  }}
                                >
                                  <StarIcon sx={{ fontSize: '1.25rem' }} />
                                </Box>
                              </ListItemIcon>
                              <ListItemText
                                primary={item.benefit}
                                secondary={item.description}
                                primaryTypographyProps={{
                                  fontWeight: 600,
                                  color: 'primary.main',
                                  gutterBottom: true
                                }}
                                secondaryTypographyProps={{
                                  sx: { lineHeight: 1.6 }
                                }}
                              />
                            </ListItem>
                          ))}
                        </List>
                      )}

                      {/* Nested Content */}
                      {section.initialAssessment && (
                        <Box sx={{ mb: 3 }}>
                          <Typography 
                            variant="subtitle1" 
                            sx={{ 
                              mb: 2,
                              fontWeight: 600,
                              color: '#1976d2'
                            }}
                          >
                            {section.initialAssessment.title}
                          </Typography>
                          {section.initialAssessment.content && (
                            <Typography 
                              variant="body1" 
                              sx={{ 
                                mb: 2,
                                lineHeight: 1.7
                              }}
                            >
                              {section.initialAssessment.content}
                            </Typography>
                          )}
                          {section.initialAssessment.principles && (
                            <List>
                              {section.initialAssessment.principles.map((principle, index) => (
                                <ListItem 
                                  key={index}
                                  sx={{
                                    bgcolor: 'background.paper',
                                    borderRadius: 1,
                                    mb: 1,
                                    boxShadow: 1
                                  }}
                                >
                                  <ListItemIcon>
                                    <ArrowRight sx={{ color: '#4caf50' }} />
                                  </ListItemIcon>
                                  <ListItemText
                                    primary={principle.name}
                                    secondary={principle.description}
                                    primaryTypographyProps={{
                                      fontWeight: 500,
                                      color: 'primary.main'
                                    }}
                                    secondaryTypographyProps={{
                                      sx: { mt: 0.5 }
                                    }}
                                  />
                                </ListItem>
                              ))}
                            </List>
                          )}
                          {section.initialAssessment.steps && (
                            <List sx={{ mt: 2 }}>
                              {section.initialAssessment.steps.map((step, index) => (
                                <ListItem 
                                  key={index}
                                  sx={{
                                    bgcolor: 'background.paper',
                                    borderRadius: 1,
                                    mb: 1,
                                    boxShadow: 1
                                  }}
                                >
                                  <ListItemIcon>
                                    <Box
                                      sx={{
                                        width: 24,
                                        height: 24,
                                        borderRadius: '50%',
                                        bgcolor: 'primary.main',
                                        color: 'white',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        fontWeight: 'bold',
                                        fontSize: '0.875rem'
                                      }}
                                    >
                                      {step.step}
                                    </Box>
                                  </ListItemIcon>
                                  <ListItemText
                                    primary={step.title}
                                    secondary={step.description}
                                    primaryTypographyProps={{
                                      fontWeight: 500,
                                      color: 'primary.main'
                                    }}
                                    secondaryTypographyProps={{
                                      sx: { mt: 0.5 }
                                    }}
                                  />
                                </ListItem>
                              ))}
                            </List>
                          )}
                        </Box>
                      )}
                      
                      {/* Signs and Symptoms of Cardiac Arrest */}
                      {section.symptoms && section.title === 'Signs and Symptoms of Cardiac Arrest' && (
                        <Box>
                          <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary', fontSize: '1.1rem', lineHeight: 1.6 }}>
                            {/* {section.description} */}
                          </Typography>

                          {/* Main Symptoms */}
                          {/* <Typography variant="h6" sx={{ mb: 3, color: 'text.primary', fontWeight: 600 }}>
                            Primary Signs
                          </Typography> */}

                          {/* Emergency Response Protocols */}
                          {activeLesson.content.mainContent?.emergencyResponse && (
                            <Box sx={{ mt: 4, mb: 4 }}>
                              <Typography variant="h6" sx={{ mb: 3, color: 'text.primary', fontWeight: 600 }}>
                                {activeLesson.content.mainContent.emergencyResponse.title}
                              </Typography>
                              <Typography variant="body1" sx={{ mb: 3, color: 'text.secondary' }}>
                                {activeLesson.content.mainContent.emergencyResponse.description}
                              </Typography>
                              <Grid container spacing={3}>
                                {activeLesson.content.mainContent.emergencyResponse.protocols.map((protocol, index) => (
                                  <Grid item xs={12} md={4} key={index}>
                                    <Paper
                                      elevation={2}
                                      sx={{
                                        p: 3,
                                        height: '100%',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        bgcolor: 'background.paper',
                                        borderRadius: 2,
                                        border: '1px solid',
                                        borderColor: 'divider'
                                      }}
                                    >
                                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                                        <Icon sx={{ mr: 1, color: protocol.color }}>{protocol.icon}</Icon>
                                        <Typography variant="subtitle1" sx={{ fontWeight: 600, color: protocol.color }}>
                                          {protocol.scenario}
                                        </Typography>
                                      </Box>
                                      <Typography variant="body2" sx={{ color: 'text.secondary', flex: 1 }}>
                                        {protocol.action}
                                      </Typography>
                                    </Paper>
                                  </Grid>
                                ))}
                              </Grid>
                            </Box>
                          )}

                          {/* Quiz Section */}
                          {/* {activeLesson.content.quiz && (
                            <Box sx={{ mt: 6 }}>
                              <Paper
                                elevation={3}
                                sx={{
                                  p: 4,
                                  borderRadius: 2,
                                  bgcolor: 'background.paper',
                                  border: '1px solid',
                                  borderColor: 'divider'
                                }}
                              >
                                <Typography variant="h6" sx={{ mb: 3, color: 'primary.main', fontWeight: 600 }}>
                                  {activeLesson.content.quiz.title}
                                </Typography>
                                <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
                                  {activeLesson.content.quiz.description}
                                </Typography>

                                {activeLesson.content.quiz.questions.map((question, qIndex) => (
                                  <Box key={qIndex} sx={{ mb: 4 }}>
                                    <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 500 }}>
                                      {qIndex + 1}. {question.question}
                                    </Typography>

                                    <RadioGroup
                                      name={`question-${question.id || qIndex}`}
                                      value={quizAnswers[question.id] || ''}
                                      onChange={(e) => handleAnswerSelect(question.id, e.target.value)}
                                    >
                                      {question.options.map((option, oIndex) => (
                                        <FormControlLabel
                                          key={oIndex}
                                          value={oIndex}
                                          control={
                                            <Radio
                                              sx={{
                                                '&.Mui-checked': {
                                                  color: showAnswers
                                                    ? oIndex === question.correctAnswer
                                                      ? 'success.main'
                                                      : 'error.main'
                                                    : 'primary.main'
                                                }
                                              }}
                                            />
                                          }
                                          label={option}
                                          sx={{
                                            mb: 1,
                                            ml: 1,
                                            '& .MuiFormControlLabel-label': {
                                              color: showAnswers
                                                ? oIndex === question.correctAnswer
                                                  ? 'success.main'
                                                  : quizAnswers[question.id] === String(oIndex)
                                                  ? 'error.main'
                                                  : 'text.primary'
                                                : 'text.primary'
                                            }
                                          }}
                                          disabled={showAnswers}
                                        />
                                      ))}
                                    </RadioGroup>

                                    {showAnswers && (
                                      <Box
                                        sx={{
                                          mt: 2,
                                          p: 2,
                                          bgcolor: 'info.soft',
                                          borderRadius: 1,
                                          display: 'flex',
                                          alignItems: 'flex-start'
                                        }}
                                      >
                                        <InfoIcon sx={{ mr: 1, color: 'info.main', mt: 0.5 }} />
                                        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                                          {question.explanation}
                                        </Typography>
                                      </Box>
                                    )}
                                  </Box>
                                ))}

                                <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
                                  <Button
                                    variant="contained"
                                    color={showAnswers ? 'primary' : 'success'}
                                    onClick={showAnswers ? handleRetryQuiz : handleSubmitAllAnswers}
                                    startIcon={showAnswers ? <RefreshIcon /> : <CheckCircleIcon />}
                                    size="large"
                                  >
                                    {showAnswers ? 'Retry Quiz' : 'Submit Answers'}
                                  </Button>
                                </Box>
                              </Paper>
                            </Box>
                          )} */}
                          
                          {/* Main Symptoms */}
                          {/* <Typography variant="h6" sx={{ mb: 3, color: 'text.primary', fontWeight: 600 }}>
                            Primary Signs
                          </Typography>
                          <Grid container spacing={3} sx={{ mb: 6 }}>
                            {section.symptoms.map((symptom, index) => (
                              <Grid item xs={12} md={6} key={index}>
                                <Paper
                                  elevation={3}
                                  sx={{
                                    p: 3,
                                    height: '100%',
                                    borderRadius: 2,
                                    bgcolor: 'background.paper',
                                    position: 'relative',
                                    overflow: 'hidden',
                                    borderLeft: `6px solid ${symptom.color}`,
                                    '&:hover': {
                                      boxShadow: 6,
                                      transform: 'translateY(-2px)',
                                      transition: 'all 0.3s ease'
                                    }
                                  }}
                                >
                                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                                    <Box
                                      sx={{
                                        bgcolor: `${symptom.color}15`,
                                        p: 1,
                                        borderRadius: '50%',
                                        mr: 2,
                                        display: 'flex',
                                        alignItems: 'center'
                                      }}
                                    >
                                      {symptom.icon === 'Person' && <PersonIcon sx={{ color: symptom.color }} />}
                                      {symptom.icon === 'Air' && <AirIcon sx={{ color: symptom.color }} />}
                                      {symptom.icon === 'MonitorHeart' && <MonitorHeartIcon sx={{ color: symptom.color }} />}
                                      {symptom.icon === 'Colorize' && <ColorizeIcon sx={{ color: symptom.color }} />}
                                      {symptom.icon === 'Visibility' && <VisibilityIcon sx={{ color: symptom.color }} />}
                                      {symptom.icon === 'AccessibilityNew' && <AccessibilityNewIcon sx={{ color: symptom.color }} />}
                                      {symptom.icon === 'HealthAndSafety' && <HealthAndSafetyIcon sx={{ color: symptom.color }} />}
                                      {symptom.icon === 'ReportProblem' && <ReportProblemIcon sx={{ color: symptom.color }} />}
                                    </Box>
                                    <Typography variant="h6" sx={{ color: 'text.primary', fontWeight: 600 }}>
                                      {symptom.title}
                                    </Typography>
                                  </Box>
                                  
                                  <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
                                    {symptom.description}
                                  </Typography>
                                  
                                  <Box sx={{ display: 'flex', gap: 1, mt: 'auto' }}>
                                    <Chip
                                      label={symptom.severity}
                                      size="small"
                                      sx={{
                                        bgcolor: `${symptom.color}15`,
                                        color: symptom.color,
                                        fontWeight: 500
                                      }}
                                    />
                                    <Chip
                                      label={symptom.timeFrame}
                                      size="small"
                                      sx={{
                                        bgcolor: 'grey.100',
                                        color: 'text.secondary',
                                        fontWeight: 500
                                      }}
                                    />
                                  </Box>
                                </Paper>
                              </Grid>
                            ))}
                          </Grid> */}

                          {/* Preceding Symptoms */}
                          <Typography variant="h6" sx={{ mb: 3, color: 'text.primary', fontWeight: 600 }}>
                            Warning Signs That May Precede Cardiac Arrest
                          </Typography>
                          <Grid container spacing={3}>
                            {section.precedingSymptoms.map((symptom, index) => (
                              <Grid item xs={12} md={6} key={index}>
                                <Paper
                                  elevation={3}
                                  sx={{
                                    p: 3,
                                    height: '100%',
                                    borderRadius: 2,
                                    bgcolor: `${symptom.color}08`,
                                    position: 'relative',
                                    overflow: 'hidden'
                                  }}
                                >
                                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                                    <Box
                                      sx={{
                                        bgcolor: `${symptom.color}15`,
                                        p: 1,
                                        borderRadius: '50%',
                                        mr: 2
                                      }}
                                    >
                                      {symptom.icon === 'Person' && <PersonIcon sx={{ color: symptom.color }} />}
                                      {symptom.icon === 'Air' && <AirIcon sx={{ color: symptom.color }} />}
                                      {symptom.icon === 'MonitorHeart' && <MonitorHeartIcon sx={{ color: symptom.color }} />}
                                      {symptom.icon === 'Colorize' && <ColorizeIcon sx={{ color: symptom.color }} />}
                                      {symptom.icon === 'Visibility' && <VisibilityIcon sx={{ color: symptom.color }} />}
                                      {symptom.icon === 'AccessibilityNew' && <AccessibilityNewIcon sx={{ color: symptom.color }} />}
                                      {symptom.icon === 'HealthAndSafety' && <HealthAndSafetyIcon sx={{ color: symptom.color }} />}
                                      {symptom.icon === 'ReportProblem' && <ReportProblemIcon sx={{ color: symptom.color }} />}
                                    </Box>
                                    <Typography variant="h6" sx={{ color: symptom.color, fontWeight: 600 }}>
                                      {symptom.title}
                                    </Typography>
                                  </Box>
                                  <Typography variant="body1" sx={{ color: 'text.secondary' }}>
                                    {symptom.description}
                                  </Typography>
                                </Paper>
                              </Grid>
                            ))}
                          </Grid>

                          {/* Quiz Section */}
                          {section.quiz && (
                            <Box sx={{ mt: 6 }}>
                              <Paper
                                elevation={3}
                                sx={{
                                  p: 4,
                                  borderRadius: 2,
                                  bgcolor: 'background.paper',
                                  border: '1px solid',
                                  borderColor: 'divider'
                                }}
                              >
                                <Typography variant="h5" sx={{ mb: 3, color: 'primary.main', fontWeight: 600 }}>
                                  {section.quiz.title}
                                </Typography>
                                <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
                                  {section.quiz.description}
                                </Typography>

                                {section.quiz.questions.map((question, qIndex) => (
                                  <Box key={qIndex} sx={{ mb: 4 }}>
                                    <Typography
                                      variant="h6"
                                      sx={{
                                        mb: 2,
                                        color: 'text.primary',
                                        fontWeight: 500,
                                        display: 'flex',
                                        alignItems: 'center'
                                      }}
                                    >
                                      <QuizIcon sx={{ mr: 1, color: 'primary.main' }} />
                                      Question {qIndex + 1}: {question.question}
                                    </Typography>

                                    <RadioGroup
                                      name={`question-${question.id || qIndex}`}
                                      value={quizAnswers[question.id] || ''}
                                      onChange={(e) => handleAnswerSelect(question.id, e.target.value)}
                                    >
                                      {question.options.map((option, oIndex) => (
                                        <FormControlLabel
                                          key={oIndex}
                                          value={oIndex}
                                          control={
                                            <Radio
                                              sx={{
                                                '&.Mui-checked': {
                                                  color: showAnswers
                                                    ? oIndex === question.correctAnswer
                                                      ? 'success.main'
                                                      : 'error.main'
                                                    : 'primary.main'
                                                }
                                              }}
                                            />
                                          }
                                          label={option}
                                          sx={{
                                            mb: 1,
                                            ml: 1,
                                            '& .MuiFormControlLabel-label': {
                                              color: showAnswers
                                                ? oIndex === question.correctAnswer
                                                  ? 'success.main'
                                                  : quizAnswers[question.id] === String(oIndex)
                                                  ? 'error.main'
                                                  : 'text.primary'
                                                : 'text.primary'
                                            }
                                          }}
                                          disabled={showAnswers}
                                        />
                                      ))}
                                    </RadioGroup>

                                    {showAnswers && (
                                      <Box
                                        sx={{
                                          mt: 2,
                                          p: 2,
                                          bgcolor: 'info.soft',
                                          borderRadius: 1,
                                          display: 'flex',
                                          alignItems: 'flex-start'
                                        }}
                                      >
                                        <InfoIcon sx={{ mr: 1, color: 'info.main', mt: 0.5 }} />
                                        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                                          {question.explanation}
                                        </Typography>
                                      </Box>
                                    )}
                                  </Box>
                                ))}

                                <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
                                  <Button
                                    variant="contained"
                                    color={showAnswers ? 'primary' : 'success'}
                                    onClick={showAnswers ? handleRetryQuiz : handleSubmitAllAnswers}
                                    startIcon={showAnswers ? <RefreshIcon /> : <CheckCircleIcon />}
                                    size="large"
                                  >
                                    {showAnswers ? 'Retry Quiz' : 'Submit Answers'}
                                  </Button>
                                </Box>
                              </Paper>
                            </Box>
                          )}
                        </Box>
                      )}

                      {/* Primary Survey (ABCDE Approach) */}
                      {section.steps && section.title === 'Primary Survey (ABCDE Approach)' && (
                        <Box>
                          <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary', fontSize: '1.1rem', lineHeight: 1.6 }}>
                            {section.description}
                          </Typography>
                          <Grid container spacing={3}>
                            {section.steps.map((step, index) => (
                              <Grid item xs={12} key={index}>
                                <Paper
                                  elevation={3}
                                  sx={{
                                    p: 4,
                                    borderRadius: 3,
                                    bgcolor: 'background.paper',
                                    position: 'relative',
                                    overflow: 'hidden',
                                    borderLeft: `8px solid ${step.color}`,
                                    '&:hover': {
                                      boxShadow: 6,
                                      transform: 'translateY(-2px)',
                                      transition: 'all 0.3s ease'
                                    }
                                  }}
                                >
                                  <Grid container spacing={3}>
                                    <Grid item xs={12} sm={3} md={2}>
                                      <Box
                                        sx={{
                                          display: 'flex',
                                          flexDirection: 'column',
                                          alignItems: 'center',
                                          justifyContent: 'center',
                                          height: '100%',
                                          position: 'relative'
                                        }}
                                      >
                                        <Typography
                                          variant="h1"
                                          sx={{
                                            color: step.color,
                                            fontWeight: 800,
                                            mb: 1,
                                            fontSize: '4rem',
                                            textShadow: '2px 2px 4px rgba(0,0,0,0.1)'
                                          }}
                                        >
                                          {step.letter}
                                        </Typography>
                                        <Typography
                                          variant="h5"
                                          sx={{
                                            color: step.color,
                                            fontWeight: 600,
                                            textAlign: 'center',
                                            textTransform: 'uppercase',
                                            letterSpacing: '0.5px'
                                          }}
                                        >
                                          {step.title}
                                        </Typography>
                                      </Box>
                                    </Grid>
                                    <Grid item xs={12} sm={9} md={10}>
                                      <Box sx={{ mb: 2 }}>
                                        <Typography
                                          variant="h6"
                                          sx={{
                                            mb: 1,
                                            color: 'text.primary',
                                            fontWeight: 600
                                          }}
                                        >
                                          {step.description}
                                        </Typography>
                                        <Chip
                                          label={step.importance}
                                          sx={{
                                            bgcolor: `${step.color}15`,
                                            color: step.color,
                                            fontWeight: 500,
                                            mb: 2
                                          }}
                                        />
                                      </Box>
                                      <List sx={{ mb: 2 }}>
                                        {step.checkPoints.map((point, idx) => (
                                          <ListItem key={idx} sx={{ py: 0.5 }}>
                                            <ListItemIcon>
                                              <CheckCircle sx={{ color: step.color, fontSize: '1.2rem' }} />
                                            </ListItemIcon>
                                            <ListItemText
                                              primary={point}
                                              sx={{
                                                '& .MuiListItemText-primary': {
                                                  color: 'text.primary',
                                                  fontWeight: 500
                                                }
                                              }}
                                            />
                                          </ListItem>
                                        ))}
                                      </List>
                                      {step.warningSign && (
                                        <Box
                                          sx={{
                                            mt: 2,
                                            p: 2,
                                            bgcolor: `${step.color}10`,
                                            borderRadius: 2,
                                            display: 'flex',
                                            alignItems: 'center'
                                          }}
                                        >
                                          <WarningIcon sx={{ color: step.color, mr: 1 }} />
                                          <Typography sx={{ color: 'text.secondary', fontWeight: 500 }}>
                                            Warning Signs: {step.warningSign}
                                          </Typography>
                                        </Box>
                                      )}
                                    </Grid>
                                  </Grid>
                                </Paper>
                              </Grid>
                            ))}
                          </Grid>
                        </Box>
                      )}

                      {/* Communication Guidelines */}
                      {section.guidelines && (
                        <Box>
                          {section.guidelines.map((guideline, index) => (
                            <Box key={index} sx={{ mb: 4 }}>
                              <Typography
                                variant="h6"
                                sx={{
                                  mb: 3,
                                  color: 'primary.main',
                                  fontWeight: 600
                                }}
                              >
                                {guideline.title}
                              </Typography>
                              <Grid container spacing={2}>
                                {guideline.components.map((component, idx) => (
                                  <Grid item xs={12} sm={6} md={3} key={idx}>
                                    <Paper
                                      elevation={2}
                                      sx={{
                                        p: 2,
                                        height: '100%',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        textAlign: 'center',
                                        borderRadius: 2,
                                        bgcolor: 'background.paper',
                                        position: 'relative',
                                        overflow: 'hidden',
                                        '&::before': {
                                          content: '""',
                                          position: 'absolute',
                                          top: 0,
                                          left: 0,
                                          right: 0,
                                          height: '4px',
                                          background: 'primary.main'
                                        }
                                      }}
                                    >
                                      <Typography
                                        variant="h4"
                                        sx={{
                                          color: 'primary.main',
                                          fontWeight: 'bold',
                                          mb: 1
                                        }}
                                      >
                                        {component.letter}
                                      </Typography>
                                      <Typography
                                        variant="subtitle1"
                                        sx={{
                                          fontWeight: 600,
                                          color: 'text.primary',
                                          mb: 1
                                        }}
                                      >
                                        {component.meaning}
                                      </Typography>
                                      <Typography
                                        variant="body2"
                                        sx={{ color: 'text.secondary' }}
                                      >
                                        {component.description}
                                      </Typography>
                                    </Paper>
                                  </Grid>
                                ))}
                              </Grid>
                            </Box>
                          ))}
                        </Box>
                      )}

                      {/* Principles List */}
                      {section.principles && (
                        <List>
                          {section.principles.map((item, index) => (
                            <ListItem 
                              key={index}
                              sx={{
                                bgcolor: 'background.paper',
                                borderRadius: 1,
                                mb: 1,
                                boxShadow: 1
                              }}
                            >
                              <ListItemIcon>
                                <ArrowRight sx={{ color: 'primary.main' }} />
                              </ListItemIcon>
                              <ListItemText
                                primary={item.name}
                                secondary={item.description}
                                primaryTypographyProps={{
                                  fontWeight: 500,
                                  color: 'primary.main'
                                }}
                                secondaryTypographyProps={{
                                  sx: { mt: 0.5 }
                                }}
                              />
                            </ListItem>
                          ))}
                        </List>
                      )}

                      {/* Time Factors List */}
                      {section.timeFactors && (
                        <List>
                          {section.timeFactors.map((factor, index) => (
                            <ListItem 
                              key={index}
                              sx={{
                                bgcolor: 'background.paper',
                                borderRadius: 1,
                                mb: 1,
                                boxShadow: 1
                              }}
                            >
                              <ListItemIcon>
                                <TimerIcon sx={{ color: '#ff9800' }} />
                              </ListItemIcon>
                              <ListItemText
                                primary={factor}
                                primaryTypographyProps={{
                                  sx: { fontWeight: 500 }
                                }}
                              />
                            </ListItem>
                          ))}
                        </List>
                      )}
                    </Paper>
                  )})}
                </Box>
              )}

              {/* Statistics */}
              {activeLesson.content.statistics && (
                <Paper 
                  elevation={1} 
                  sx={{ 
                    p: 4, 
                    mb: 4, 
                    borderRadius: 2,
                    bgcolor: '#f5f5f5'
                  }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                    <TimerIcon sx={{ mr: 1, color: '#ff9800' }} />
                    <Typography variant="h6" sx={{ fontWeight: 600 }}>
                      {activeLesson.content.statistics.title}
                    </Typography>
                  </Box>
                  <List>
                    {activeLesson.content.statistics.data.map((stat, index) => (
                      <ListItem 
                        key={index}
                        sx={{
                          bgcolor: 'white',
                          borderRadius: 1,
                          mb: 1,
                          boxShadow: 1
                        }}
                      >
                        <ListItemIcon>
                          <ArrowRight sx={{ color: '#ff9800' }} />
                        </ListItemIcon>
                        <ListItemText 
                          primary={stat}
                          primaryTypographyProps={{
                            sx: { fontWeight: 500 }
                          }}
                        />
                      </ListItem>
                    ))}
                  </List>
                </Paper>
              )}

              {/* Key Points */}
              {activeLesson.content.keyPoints && (
                <Paper 
                  elevation={1} 
                  sx={{ 
                    p: 4, 
                    mb: 4, 
                    borderRadius: 2,
                    bgcolor: '#e8f5e9',
                    borderLeft: '4px solid #4caf50'
                  }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                    <CheckCircle sx={{ mr: 1, color: '#4caf50' }} />
                    <Typography variant="h6" sx={{ fontWeight: 600 }}>
                      Key Points
                    </Typography>
                  </Box>
                  <List>
                    {activeLesson.content.keyPoints.map((point, index) => (
                      <ListItem 
                        key={index}
                        sx={{
                          bgcolor: 'white',
                          borderRadius: 1,
                          mb: 1,
                          boxShadow: 1
                        }}
                      >
                        <ListItemIcon>
                          <CheckCircle sx={{ color: '#4caf50' }} />
                        </ListItemIcon>
                        <ListItemText 
                          primary={point}
                          primaryTypographyProps={{
                            sx: { fontWeight: 500 }
                          }}
                        />
                      </ListItem>
                    ))}
                  </List>
                </Paper>
              )}

              {/* Quiz Section */}
              {activeLesson.content.quiz && (
                <Paper 
                  elevation={1} 
                  sx={{ 
                    p: 4, 
                    mb: 4, 
                    borderRadius: 2,
                    borderLeft: '4px solid #ff9800'
                  }}
                >
                  <Typography 
                    variant="h6" 
                    sx={{ 
                      mb: 3,
                      fontWeight: 600,
                      color: '#ff9800',
                      display: 'flex',
                      alignItems: 'center'
                    }}
                  >
                    <QuizIcon sx={{ mr: 1 }} />
                    {activeLesson.content.quiz.title}
                  </Typography>

                  <Typography 
                    variant="body1" 
                    sx={{ 
                      mb: 4,
                      color: 'text.secondary'
                    }}
                  >
                    {activeLesson.content.quiz.description}
                  </Typography>

                  {activeLesson.content.quiz.questions.map((question, index) => (
                    <Box key={index} sx={{ mb: 4 }}>
                      <Typography 
                        variant="subtitle1" 
                        sx={{ 
                          mb: 2,
                          fontWeight: 500,
                          display: 'flex',
                          alignItems: 'center'
                        }}
                      >
                        <Box
                          sx={{
                            minWidth: 28,
                            height: 28,
                            borderRadius: '50%',
                            bgcolor: 'primary.main',
                            color: 'white',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontWeight: 'bold',
                            fontSize: '0.875rem',
                            mr: 2
                          }}
                        >
                          {index + 1}
                        </Box>
                        {question.question}
                      </Typography>

                      <Box sx={{ pl: 2 }}>
                        <RadioGroup
                          aria-labelledby={`question-${question.id}-label`}
                          name={`radio-group-${question.id}`}
                          value={quizAnswers[question.id] || ''}
                          onChange={(e) => {
                            handleAnswerSelect(question.id, e.target.value);
                          }}
                        >
                          {question.options?.map((option, optionIndex) => {
                            const optionId = `option-${question.id}-${optionIndex}`;
                            return (
                              <FormControlLabel
                                key={optionId}
                                value={String(optionIndex)}
                                control={<Radio />}
                                label={
                                  <Typography variant="body2">
                                    {option}
                                  </Typography>
                                }
                                disabled={showAllAnswers}
                                sx={{
                                  mb: 1,
                                  '& .MuiFormControlLabel-label': {
                                    fontSize: '0.9rem',
                                    userSelect: 'none',
                                    ml: 1
                                  }
                                }}
                              />
                            );
                          })}
                        </RadioGroup>
                      </Box>


                      {!showAllAnswers && (
                        <Box sx={{ mt: 2 }}>
                          <Button
                            variant="outlined"
                            color="primary"
                            size="small"
                            onClick={() => handleCheckAnswer(question.id)}
                            disabled={!quizAnswers.hasOwnProperty(question.id) || showAllAnswers}
                          >
                            Check Answer
                          </Button>
                        </Box>
                      )}

                      {(showAllAnswers || quizFeedback[question.id]) && (
                        <Paper
                          sx={{
                            mt: 2,
                            p: 2,
                            bgcolor: (showAllAnswers ? 
                              (quizAnswers[question.id] === question.correctAnswer ? '#e8f5e9' : '#ffebee') : 
                              (quizFeedback[question.id]?.isCorrect ? '#e8f5e9' : '#ffebee')),
                            borderRadius: 1
                          }}
                        >
                          <Typography
                            variant="body2"
                            sx={{
                              color: (showAllAnswers ?
                                (quizAnswers[question.id] === question.correctAnswer ? '#2e7d32' : '#c62828') :
                                (quizFeedback[question.id]?.isCorrect ? '#2e7d32' : '#c62828')),
                              fontWeight: 500,
                              mb: 1
                            }}
                          >
                            {showAllAnswers ? 
                              (quizAnswers[question.id] === question.correctAnswer ? '✓ Correct!' : '✗ Incorrect') :
                              (quizFeedback[question.id]?.isCorrect ? '✓ Correct!' : '✗ Incorrect')}
                          </Typography>
                          <Typography variant="body2">
                            {showAllAnswers ? 
                              (question.explanation || (quizAnswers[question.id] === question.correctAnswer ? 'Correct!' : 'Incorrect answer.')) :
                              (quizFeedback[question.id]?.explanation || '')}
                          </Typography>
                        </Paper>
                      )}
                    </Box>
                  ))}
                  
                  {/* Submit All / Retry Buttons */}
                  <Box sx={{ mt: 4, display: 'flex', justifyContent: 'center', gap: 2 }}>
                    {/* {!showAllAnswers ? (
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={handleSubmitAllAnswers}
                        disabled={Object.keys(quizAnswers).length < activeLesson.content.quiz.questions.length}
                      >
                        Submit All Answers
                      </Button>
                    ) : (
                      <Button
                        variant="outlined"
                        color="primary"
                        onClick={handleRetryQuiz}
                      >
                        Retry Quiz
                      </Button>
                    )} */}
                  </Box>
                </Paper>
              )}

              {/* Recovery Position Lesson - Custom Rendering */}
              {activeLesson.id === '4.7' && (
                <Paper 
                  elevation={1} 
                  sx={{ 
                    p: 4, 
                    mb: 4, 
                    borderRadius: 2,
                    borderLeft: '4px solid #1976d2'
                  }}
                >
                  {/* Overview Section */}
                  {activeLesson.content.mainContent.overview && (
                    <Box sx={{ mb: 4 }}>
                      <Typography 
                        variant="h6" 
                        sx={{ 
                          mb: 2,
                          fontWeight: 600,
                          color: '#1976d2',
                          display: 'flex',
                          alignItems: 'center'
                        }}
                      >
                        <InfoIcon sx={{ mr: 1 }} />
                        {activeLesson.content.mainContent.overview.title}
                      </Typography>
                      
                      <Typography   
                        variant="body1" 
                        sx={{ 
                          mb: 3,
                          lineHeight: 1.7
                        }}
                      >
                        {activeLesson.content.mainContent.overview.description}
                      </Typography>

                      {/* Key Points */}
                      {activeLesson.content.mainContent.overview.keyPoints && (
                        <Box sx={{ 
                          bgcolor: '#f5f5f5', 
                          p: 2, 
                          borderRadius: 1,
                          mt: 2
                        }}>
                          <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1 }}>
                            Key Points:
                          </Typography>
                          <List dense>
                            {activeLesson.content.mainContent.overview.keyPoints.map((point, index) => (
                              <ListItem key={index}>
                                <ListItemIcon>
                                  <FiberManualRecordIcon sx={{ fontSize: 10, color: '#1976d2' }} />
                                </ListItemIcon>
                                <ListItemText primary={point} />
                              </ListItem>
                            ))}
                          </List>
                        </Box>
                      )}
                    </Box>
                  )}

                  {/* Recovery Position Steps */}
                  {activeLesson.content.mainContent.recoveryPositionSteps && (
                    <Box sx={{ mb: 4 }}>
                      <Typography 
                        variant="h6" 
                        sx={{ 
                          mb: 3,
                          fontWeight: 600,
                          color: '#1976d2',
                          display: 'flex',
                          alignItems: 'center'
                        }}
                      >
                        <AccessibilityNewIcon sx={{ mr: 1 }} />
                        {activeLesson.content.mainContent.recoveryPositionSteps.title}
                      </Typography>

                      <Stepper orientation="vertical" sx={{ mt: 3 }}>
                        {activeLesson.content.mainContent.recoveryPositionSteps.steps.map((step, index) => (
                          <Step key={index} active={true}>
                            <StepLabel 
                              StepIconProps={{
                                sx: { color: '#1976d2' }
                              }}
                            >
                              <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                                {step.title}
                              </Typography>
                            </StepLabel>
                            <StepContent>
                              <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.7 }}>
                                {step.description}
                              </Typography>
                            </StepContent>
                          </Step>
                        ))}
                      </Stepper>
                    </Box>
                  )}

                  {/* Important Considerations */}
                  {/* {activeLesson.content.mainContent.importantConsiderations && sectionToRender.id!='4.7'(
                    <Box sx={{ mt: 4 }}>
                      <Paper 
                        elevation={0} 
                        sx={{ 
                          p: 3, 
                          bgcolor: '#fff8e1', 
                          borderRadius: 2,
                          border: '1px solid #ffecb3'
                        }}
                      >
                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                          <LightbulbIcon sx={{ mr: 1, color: '#ff9800' }} />
                          <Typography variant="h6" sx={{ fontWeight: 600, color: '#ff9800' }}>
                            {activeLesson.content.mainContent.importantConsiderations.title}
                          </Typography>
                        </Box>
                        <Typography variant="body1" sx={{ lineHeight: 1.7 }}>
                          {activeLesson.content.mainContent.importantConsiderations.description}
                        </Typography>
                      </Paper>
                    </Box>
                  )} */}
                </Paper>
              )}

              {/* Summary */}
              {activeLesson.content.summary && (
                <Paper 
                  elevation={1} 
                  sx={{ 
                    p: 4, 
                    mb: 4, 
                    borderRadius: 2,
                    bgcolor: '#fff3e0',
                    borderLeft: '4px solid #ff9800'
                  }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                    <MenuBookIcon sx={{ mr: 1, color: '#ff9800' }} />
                    <Typography variant="h6" sx={{ fontWeight: 600 }}>
                      Summary
                    </Typography>
                  </Box>
                  <Typography 
                    variant="body1"
                    sx={{ 
                      bgcolor: 'white',
                      p: 3,
                      borderRadius: 1,
                      boxShadow: 1,
                      lineHeight: 1.7
                    }}
                  >
                    {activeLesson.content.summary}
                  </Typography>
                </Paper>
              )}

              {/* Navigation buttons */}
              <Box 
                sx={{ 
                  mt: 4, 
                  pt: 3,
                  display: 'flex', 
                  justifyContent: 'space-between',
                  borderTop: '1px solid #e0e0e0'
                }}
              >
                <Button
                  startIcon={<ArrowBackIcon />}
                  onClick={handlePreviousLesson}
                  disabled={!hasPreviousLesson}
                  variant="outlined"
                  sx={{ px: 3 }}
                >
                  Previous Lesson
                </Button>
                <Button
                  endIcon={<ArrowForwardIcon />}
                  onClick={handleNextLesson}
                  disabled={!hasNextLesson}
                  variant="contained"
                  sx={{ px: 3 }}
                >
                  Next Lesson
                </Button>
              </Box>
            </Box>
          ) : (
            <Paper sx={{ p: 4, textAlign: 'center' }}>
              <Typography>Lesson not found</Typography>
            </Paper>
          )}
        </Grid>
      </Grid>
    </Container>
  );
};

export default BLSCPRModule;
